(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global $ */

/**
 *  Util initialization Class. Provides public functions
 *  - getCurrentTimeISOStandard
 *  - getCurrentTime
 *  - getCookie
 *  - getAppVersion
 *  - logInfoToBackend
 *  - updateStatementObjectToPostToLRS
 *  - createStatementObject
 */
var Utils = function () {
    function Utils() {
        _classCallCheck(this, Utils);
    }

    _createClass(Utils, null, [{
        key: 'getCurrentTimeISOStandard',
        value: function getCurrentTimeISOStandard(date) {
            var timezoneOffsetMin = date.getTimezoneOffset(),
                offsetHrs = parseInt(Math.abs(timezoneOffsetMin / 60), 10),
                offsetMin = Math.abs(timezoneOffsetMin % 60),
                timezoneStandard = void 0;

            if (offsetHrs < 10) {
                offsetHrs = '0' + offsetHrs;
            }

            if (offsetMin < 10) {
                offsetMin = '0' + offsetMin;
            }

            // Add an opposite sign to the offset // If offset is 0, it means timezone is UTC
            // Timezone difference in hours and minutes // String such as +5:30 or -6:00 or Z
            if (timezoneOffsetMin < 0) {
                timezoneStandard = '+' + offsetHrs + ':' + offsetMin;
            } else if (timezoneOffsetMin > 0) {
                timezoneStandard = '-' + offsetHrs + ':' + offsetMin;
            } else if (timezoneOffsetMin === 0) {
                timezoneStandard = 'Z';
            }

            var dt = date,
                currentDate = dt.getDate(),
                currentMonth = dt.getMonth() + 1,
                currentYear = dt.getFullYear(),
                currentHrs = dt.getHours(),
                currentMins = dt.getMinutes(),
                currentSecs = dt.getSeconds(),
                currentMillisecs = dt.getMilliseconds(),
                currentDatetime = void 0;

            // Add 0 before date, month, hrs, mins or secs if they are less than 0
            currentDate = currentDate < 10 ? '0' + currentDate : currentDate;
            currentMonth = currentMonth < 10 ? '0' + currentMonth : currentMonth;
            currentHrs = currentHrs < 10 ? '0' + currentHrs : currentHrs;
            currentMins = currentMins < 10 ? '0' + currentMins : currentMins;
            currentSecs = currentSecs < 10 ? '0' + currentSecs : currentSecs;
            currentMillisecs = currentMillisecs < 10 ? '0' + currentMillisecs : currentMillisecs;
            currentMillisecs = currentMillisecs < 100 ? '0' + currentMillisecs : currentMillisecs;

            currentDatetime = currentYear + '-' + currentMonth + '-' + currentDate + 'T' + currentHrs + ':' + currentMins + ':' + currentSecs + '.' + currentMillisecs;

            return currentDatetime + timezoneStandard;
        }
    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime(date) {
            var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
            var amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            hours = hours < 10 ? '0' + hours : hours;
            var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return (/* date.toLocaleDateString() + */hours + ':' + minutes + ':' + seconds + ' ' + amPm
            );
        }

        /** Function to get cookie - needed to set csrf-token in ajax headers
         * @param {string} name - Cookie name
        */

    }, {
        key: 'getCookie',
        value: function getCookie(name) {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (match) return match[2];
        }

        /* Function to get app version - needed to set version in ajax headers */

    }, {
        key: 'getAppVersion',
        value: function getAppVersion() {
            return 'v2';
        }

        /**
         * Wrapper around jQuery's AJAX request
         * @param {string} url - Request URL
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error handler
         * @param {('GET'|'POST'|'PUT'|'DELETE')} [requestType=GET] - 'GET'/'POST'/'PUT'/'DELETE' Request
         * @param {*} [options={}] - Other required inputs
         *        {string} userId - User ID
         * @param {*} [payload=null] - Request payload
         */

    }, {
        key: 'sendAjaxRequest',
        value: function sendAjaxRequest(url, successCallback, errorCallback) {
            var requestType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'GET';
            var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            var payload = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

            var params = {
                url: url,
                type: requestType || 'GET',
                headers: {
                    'csrf-token': Utils.getCookie('csrf-token'),
                    'cambridgeone-app-version': Utils.getAppVersion(),
                    'user-id': options.userId
                },
                xhrFields: { withCredentials: true }
            };

            if (payload) {
                params.data = payload;
            }

            if (requestType === 'GET' || requestType === 'DELETE') {
                params.cache = false;
            }

            return $.ajax(params).then(successCallback, errorCallback);
        }

        /** Function to log info to backend
         * @param {string} context
         * @param {string} extUserId
         * @param {string} spaceId
         * @param {string} productCode
         * @param {string} [classId]
         * @param {object} [data]
         * @param {object} [options]
         * @param {string} [options.serverRoutePrefix]
         * @param {string} [options.queryParams]
         */

    }, {
        key: 'logInfoToBackend',
        value: async function logInfoToBackend(context, extUserId, spaceId, productCode) {
            var classId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
            var data = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var payload = {
                context: context,
                extUserId: extUserId,
                spaceId: spaceId,
                classId: classId,
                productCode: productCode,
                data: data,
                'isUserInfoNeeded': true
            };

            var url = (options.serverRoutePrefix || '') + 'logger' + (options.queryParams || '');
            var successCallback = function successCallback(response) {
                return response;
            };

            var errorCallback = function handleError(error) {
                if (error.status === 503 || error.status === 403 && error.responseJSON && error.responseJSON.code === 'STALE_REQUEST') {
                    window.location.reload();
                } else {
                    throw error;
                }
            };
            return Utils.sendAjaxRequest(url, successCallback, errorCallback, 'POST', { userId: extUserId }, payload);
        }

        /**
         * State size should not be greater than 10 kB
         * @param {*} state
         * @return {boolean}
         */

    }, {
        key: 'isStateSizeValid',
        value: function isStateSizeValid(state) {
            return new TextEncoder().encode(JSON.stringify(state)).length / 1024 <= 10;
        }

        /** Function to update statement object to post to ComproDLS LRS.
         *  This function merge statementData from local storage(if any) with the statementArray else creates a new statementObject to store in local storage.
         *  @param {Array} statementsArray
         *  @param {Object} options
         *  @return {Object} statementData OR [entitiesArr, verbsHash]
         */

    }, {
        key: 'updateStatementObjectToPostToLRS',
        value: function updateStatementObjectToPostToLRS(statementsArray) {
            var _this = this,
                _statementData$entiti;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var verbsHash = {},
                entitiesArr = [];
            statementsArray.forEach(function (statement) {
                var _updateStatementEntit = _this.updateStatementEntities(statement, options),
                    _updateStatementEntit2 = _slicedToArray(_updateStatementEntit, 2),
                    entitiesObj = _updateStatementEntit2[0],
                    verb = _updateStatementEntit2[1];

                verbsHash[verb] = true;
                entitiesArr.push(entitiesObj);
            });

            if (options.isStatementToBeStoredInLocalStorage) return [entitiesArr, verbsHash];

            var statementData = this.createStatementObject(statementsArray, options);
            (_statementData$entiti = statementData.entities).push.apply(_statementData$entiti, entitiesArr);
            return statementData;
        }

        /** Function to create statement object to post to ComproDLS LRS.
         *  @param {Array} statementsArray
         *  @param {Object} options
         *  @return {Object} statementObject
         */

    }, {
        key: 'createStatementObject',
        value: function createStatementObject(statementsArray) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var statementObject = {
                'actor': {
                    'uuid': ''
                },
                'platform': {
                    'ua': ''
                },
                'entities': []
            };

            if (options.platformId && options.xapiId) {
                statementObject.debug = {
                    'id': options.platformId,
                    'xapiId': options.xapiId
                };
            }

            if (options.productCode) {
                statementObject.product = { 'code': options.productCode };
            }

            if (options.spaceId) {
                statementObject['space_key'] = options.spaceId;
            }

            if (options.userDetails && options.userDetails.userRole) {
                statementObject.actor.role = options.userDetails.userRole;
            }

            if (options.classId) {
                statementObject.classid = options.classId;
            }

            if (statementsArray[0].json && statementsArray[0].json.context) {
                statementObject.platform.ua = statementsArray[0].json.context.platform.ua;
                if (statementsArray[0].json.context.platform.session) statementObject.platform.session = statementsArray[0].json.context.platform.session;
            }

            if (statementsArray[0].json && statementsArray[0].json['student_userid']) {
                statementObject['student_userid'] = statementsArray[0].json['student_userid'];
            }

            if (statementsArray[0].json && statementsArray[0].json['custom_component']) {
                statementObject['custom_component'] = {
                    'code': statementsArray[0].json['custom_component'].code,
                    'title': statementsArray[0].json['custom_component'].title
                };
            }

            if (statementsArray[0].json && statementsArray[0].json.tags) {
                if (!statementObject.product) {
                    statementObject.product = {};
                }
                statementObject.product.tags = statementsArray[0].json.tags;
                if (statementsArray[0].json.definition) {
                    statementObject.product.definition = statementsArray[0].json.definition;
                }
            }

            /* For collab-group statements */
            if (statementsArray[0].json && statementsArray[0].json.group) {
                statementObject.group = statementsArray[0].json.group;
            }

            return statementObject;
        }

        /** Function to update statements object entities to post to ComproDLS LRS.
         *  @param {Object} statement
         *  @param {Object} options
         *  @return {Array} [entitiesJson, verbId]
         */

    }, {
        key: 'updateStatementEntities',
        value: function updateStatementEntities(statement, options) {
            var entitiesJson = {},
                statementJson = statement.json,
                verbId = void 0;
            if (options.assignedPathId) {
                entitiesJson['assigned_path_id'] = options.assignedPathId;
            }

            for (var key in statementJson) {
                switch (key) {
                    case 'verb':
                        {
                            verbId = statementJson[key].id.split('/');
                            verbId = verbId[verbId.length - 1];
                            entitiesJson[key] = verbId;
                            break;
                        }
                    case 'object':
                        {
                            if (statementJson[key].id) {
                                entitiesJson['item-code'] = statementJson[key].id;
                            }
                            if (statementJson[key].itemid) {
                                entitiesJson['itemid'] = statementJson[key].itemid;
                            }
                            break;
                        }
                    case 'timestamp':
                        {
                            entitiesJson[key] = this.convertTimestampToEpoc(statementJson[key]);
                            break;
                        }
                    case 'result':
                        {
                            if (statementJson[key].duration) {
                                entitiesJson['timespent'] = this.convertTimespentToEpoc(statementJson[key].duration);
                                delete statementJson[key].duration;
                            }
                            if (Object.keys(statementJson[key]).length > 0) {
                                entitiesJson[key] = statementJson[key];
                            }
                            break;
                        }
                    case 'attempt':
                        {
                            if (Object.keys(statementJson[key]).length > 0) {
                                entitiesJson[key] = statementJson[key];
                            }
                            break;
                        }
                    case 'audit_data':
                        {
                            if (Object.keys(statementJson[key]).length > 0) {
                                //Assuming timestamp will be present in statementJson as its generated in XAPIDataGenerator
                                statementJson[key]['reset_time'] = this.convertTimestampToEpoc(statementJson['timestamp']);
                                entitiesJson[key] = statementJson[key];
                            }
                            break;
                        }
                    case 'link-statementid':
                    case 'ext_link_id':
                    case 'submission_order':
                    case 'user_data':
                    case 'item-filename':
                    case 'override':
                    case 'deleted':
                    case 'item-tags':
                    case 'item-type':
                    case 'ltiPlatform':
                    case 'meta':
                    case 'audit':
                    case 'item_ext_url':
                    case 'item_title':
                    case 'xapi':
                    case 'ttl':
                        {
                            entitiesJson[key] = statementJson[key];
                            break;
                        }
                }
            }
            return [entitiesJson, verbId];
        }

        /** Function to covert timestamp to epoc standard to post to comproDLS LRS.
        *  @param {Date} time format - 2018-03-06T16:10:15.553+05:30
        *  @return {Number} time in epoc msecs
        */

    }, {
        key: 'convertTimestampToEpoc',
        value: function convertTimestampToEpoc(time) {
            var date = new Date(time);
            return date.getTime();
        }

        /** Function to covert timespent to epoc standard to post to comproDLS LRS.
         *  @param {String} time format - PT35M48.90S
         *  @return {Number} time in epoc msecs
         */

    }, {
        key: 'convertTimespentToEpoc',
        value: function convertTimespentToEpoc(time) {
            var date = time.split('PT')[1],
                timespent = 0;
            if (date.indexOf('H') >= 0) {
                var hrs = date.split('H')[0];
                date = date.split('H')[1];
                timespent += hrs * 60 * 60;
            }
            if (date.indexOf('M') >= 0) {
                var mins = date.split('M')[0];
                date = date.split('M')[1];
                timespent += mins * 60;
            }
            if (date.indexOf('S') >= 0) {
                var secs = date.split('S')[0];
                timespent += secs * 1;
            }

            return timespent * 1000;
        }

        /**
         * Checks whether the state/statement from reference class is useable for the current class and product type
         * @param {string} referenceClassId
         * @param {string} currentClassId
         * @param {boolean} [isCBPClass=false]
         * @param {boolean} [isTestTypeProduct=false]
         * @returns {boolean}
         */

    }, {
        key: 'isSyncingAllowed',
        value: function isSyncingAllowed(referenceClassId, currentClassId) {
            var isCBPClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var isTestTypeProduct = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            return (!isCBPClass || referenceClassId === currentClassId) && (!isTestTypeProduct || !referenceClassId || referenceClassId === currentClassId);
        }
    }]);

    return Utils;
}();

exports.default = Utils;
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0)(__webpack_require__(3))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = "/*!\n * visibly - v0.7 Page Visibility API Polyfill\n * http://github.com/addyosmani\n * Copyright (c) 2011-2014 Addy Osmani\n * Dual licensed under the MIT and GPL licenses.\n *\n * Methods supported:\n * visibly.onVisible(callback)\n * visibly.onHidden(callback)\n * visibly.hidden()\n * visibly.visibilityState()\n * visibly.visibilitychange(callback(state));\n */\n\n;(function () {\n\n    window.visibly = {\n        q: document,\n        p: undefined,\n        prefixes: ['webkit', 'ms','o','moz','khtml'],\n        props: ['VisibilityState', 'visibilitychange', 'Hidden'],\n        m: ['focus', 'blur'],\n        visibleCallbacks: [],\n        hiddenCallbacks: [],\n        genericCallbacks:[],\n        _callbacks: [],\n        cachedPrefix:\"\",\n        fn:null,\n\n        onVisible: function (_callback) {\n            if(typeof _callback == 'function' ){\n                this.visibleCallbacks.push(_callback);\n            }\n        },\n        onHidden: function (_callback) {\n            if(typeof _callback == 'function' ){\n                this.hiddenCallbacks.push(_callback);\n            }\n        },\n        getPrefix:function(){\n            if(!this.cachedPrefix){\n                for(var l=0;b=this.prefixes[l++];){\n                    if(b + this.props[2] in this.q){\n                        this.cachedPrefix =  b;\n                        return this.cachedPrefix;\n                    }\n                }    \n             }\n        },\n\n        visibilityState:function(){\n            return  this._getProp(0);\n        },\n        hidden:function(){\n            return this._getProp(2);\n        },\n        visibilitychange:function(fn){\n            if(typeof fn == 'function' ){\n                this.genericCallbacks.push(fn);\n            }\n\n            var n =  this.genericCallbacks.length;\n            if(n){\n                if(this.cachedPrefix){\n                     while(n--){\n                        this.genericCallbacks[n].call(this, this.visibilityState());\n                    }\n                }else{\n                    while(n--){\n                        this.genericCallbacks[n].call(this, arguments[0]);\n                    }\n                }\n            }\n\n        },\n        isSupported: function (index) {\n            return ((this._getPropName(2)) in this.q);\n        },\n        _getPropName:function(index) {\n            return (this.cachedPrefix == \"\" ? this.props[index].substring(0, 1).toLowerCase() + this.props[index].substring(1) : this.cachedPrefix + this.props[index]);\n        },\n        _getProp:function(index){\n            return this.q[this._getPropName(index)]; \n        },\n        _execute: function (index) {\n            if (index) {\n                this._callbacks = (index == 1) ? this.visibleCallbacks : this.hiddenCallbacks;\n                var n =  this._callbacks.length;\n                while(n--){\n                    this._callbacks[n]();\n                }\n            }\n        },\n        _visible: function () {\n            window.visibly._execute(1);\n            window.visibly.visibilitychange.call(window.visibly, 'visible');\n        },\n        _hidden: function () {\n            window.visibly._execute(2);\n            window.visibly.visibilitychange.call(window.visibly, 'hidden');\n        },\n        _nativeSwitch: function () {\n            this[this._getProp(2) ? '_hidden' : '_visible']();\n        },\n        _listen: function () {\n            try { /*if no native page visibility support found..*/\n                if (!(this.isSupported())) {\n                    if (this.q.addEventListener) { /*for browsers without focusin/out support eg. firefox, opera use focus/blur*/\n                        window.addEventListener(this.m[0], this._visible, 1);\n                        window.addEventListener(this.m[1], this._hidden, 1);\n                    } else { /*IE <10s most reliable focus events are onfocusin/onfocusout*/\n                        if (this.q.attachEvent) {\n                            this.q.attachEvent('onfocusin', this._visible);\n                            this.q.attachEvent('onfocusout', this._hidden);\n                        }\n                    }\n                } else { /*switch support based on prefix detected earlier*/\n                    this.q.addEventListener(this._getPropName(1), function () {\n                        window.visibly._nativeSwitch.apply(window.visibly, arguments);\n                    }, 1);\n                }\n            } catch (e) {}\n        },\n        init: function () {\n            this.getPrefix();\n            this._listen();\n        }\n    };\n\n    this.visibly.init();\n})();\n"

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0)(__webpack_require__(5))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = "/*!\n * EventEmitter v5.2.5 - git.io/ee\n * Unlicense - http://unlicense.org/\n * Oliver Caldwell - http://oli.me.uk/\n * @preserve\n */\n\n;(function (exports) {\n    'use strict';\n\n    /**\n     * Class for managing events.\n     * Can be extended to provide event functionality in other classes.\n     *\n     * @class EventEmitter Manages event registering and emitting.\n     */\n    function EventEmitter() {}\n\n    // Shortcuts to improve speed and size\n    var proto = EventEmitter.prototype;\n    var originalGlobalValue = exports.EventEmitter;\n\n    /**\n     * Finds the index of the listener for the event in its storage array.\n     *\n     * @param {Function[]} listeners Array of listeners to search through.\n     * @param {Function} listener Method to look for.\n     * @return {Number} Index of the specified listener, -1 if not found\n     * @api private\n     */\n    function indexOfListener(listeners, listener) {\n        var i = listeners.length;\n        while (i--) {\n            if (listeners[i].listener === listener) {\n                return i;\n            }\n        }\n\n        return -1;\n    }\n\n    /**\n     * Alias a method while keeping the context correct, to allow for overwriting of target method.\n     *\n     * @param {String} name The name of the target method.\n     * @return {Function} The aliased method\n     * @api private\n     */\n    function alias(name) {\n        return function aliasClosure() {\n            return this[name].apply(this, arguments);\n        };\n    }\n\n    /**\n     * Returns the listener array for the specified event.\n     * Will initialise the event object and listener arrays if required.\n     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.\n     * Each property in the object response is an array of listener functions.\n     *\n     * @param {String|RegExp} evt Name of the event to return the listeners from.\n     * @return {Function[]|Object} All listener functions for the event.\n     */\n    proto.getListeners = function getListeners(evt) {\n        var events = this._getEvents();\n        var response;\n        var key;\n\n        // Return a concatenated array of all matching events if\n        // the selector is a regular expression.\n        if (evt instanceof RegExp) {\n            response = {};\n            for (key in events) {\n                if (events.hasOwnProperty(key) && evt.test(key)) {\n                    response[key] = events[key];\n                }\n            }\n        }\n        else {\n            response = events[evt] || (events[evt] = []);\n        }\n\n        return response;\n    };\n\n    /**\n     * Takes a list of listener objects and flattens it into a list of listener functions.\n     *\n     * @param {Object[]} listeners Raw listener objects.\n     * @return {Function[]} Just the listener functions.\n     */\n    proto.flattenListeners = function flattenListeners(listeners) {\n        var flatListeners = [];\n        var i;\n\n        for (i = 0; i < listeners.length; i += 1) {\n            flatListeners.push(listeners[i].listener);\n        }\n\n        return flatListeners;\n    };\n\n    /**\n     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.\n     *\n     * @param {String|RegExp} evt Name of the event to return the listeners from.\n     * @return {Object} All listener functions for an event in an object.\n     */\n    proto.getListenersAsObject = function getListenersAsObject(evt) {\n        var listeners = this.getListeners(evt);\n        var response;\n\n        if (listeners instanceof Array) {\n            response = {};\n            response[evt] = listeners;\n        }\n\n        return response || listeners;\n    };\n\n    function isValidListener (listener) {\n        if (typeof listener === 'function' || listener instanceof RegExp) {\n            return true\n        } else if (listener && typeof listener === 'object') {\n            return isValidListener(listener.listener)\n        } else {\n            return false\n        }\n    }\n\n    /**\n     * Adds a listener function to the specified event.\n     * The listener will not be added if it is a duplicate.\n     * If the listener returns true then it will be removed after it is called.\n     * If you pass a regular expression as the event name then the listener will be added to all events that match it.\n     *\n     * @param {String|RegExp} evt Name of the event to attach the listener to.\n     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.addListener = function addListener(evt, listener) {\n        if (!isValidListener(listener)) {\n            throw new TypeError('listener must be a function');\n        }\n\n        var listeners = this.getListenersAsObject(evt);\n        var listenerIsWrapped = typeof listener === 'object';\n        var key;\n\n        for (key in listeners) {\n            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {\n                listeners[key].push(listenerIsWrapped ? listener : {\n                    listener: listener,\n                    once: false\n                });\n            }\n        }\n\n        return this;\n    };\n\n    /**\n     * Alias of addListener\n     */\n    proto.on = alias('addListener');\n\n    /**\n     * Semi-alias of addListener. It will add a listener that will be\n     * automatically removed after its first execution.\n     *\n     * @param {String|RegExp} evt Name of the event to attach the listener to.\n     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.addOnceListener = function addOnceListener(evt, listener) {\n        return this.addListener(evt, {\n            listener: listener,\n            once: true\n        });\n    };\n\n    /**\n     * Alias of addOnceListener.\n     */\n    proto.once = alias('addOnceListener');\n\n    /**\n     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.\n     * You need to tell it what event names should be matched by a regex.\n     *\n     * @param {String} evt Name of the event to create.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.defineEvent = function defineEvent(evt) {\n        this.getListeners(evt);\n        return this;\n    };\n\n    /**\n     * Uses defineEvent to define multiple events.\n     *\n     * @param {String[]} evts An array of event names to define.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.defineEvents = function defineEvents(evts) {\n        for (var i = 0; i < evts.length; i += 1) {\n            this.defineEvent(evts[i]);\n        }\n        return this;\n    };\n\n    /**\n     * Removes a listener function from the specified event.\n     * When passed a regular expression as the event name, it will remove the listener from all events that match it.\n     *\n     * @param {String|RegExp} evt Name of the event to remove the listener from.\n     * @param {Function} listener Method to remove from the event.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.removeListener = function removeListener(evt, listener) {\n        var listeners = this.getListenersAsObject(evt);\n        var index;\n        var key;\n\n        for (key in listeners) {\n            if (listeners.hasOwnProperty(key)) {\n                index = indexOfListener(listeners[key], listener);\n\n                if (index !== -1) {\n                    listeners[key].splice(index, 1);\n                }\n            }\n        }\n\n        return this;\n    };\n\n    /**\n     * Alias of removeListener\n     */\n    proto.off = alias('removeListener');\n\n    /**\n     * Adds listeners in bulk using the manipulateListeners method.\n     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.\n     * You can also pass it a regular expression to add the array of listeners to all events that match it.\n     * Yeah, this function does quite a bit. That's probably a bad thing.\n     *\n     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.\n     * @param {Function[]} [listeners] An optional array of listener functions to add.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.addListeners = function addListeners(evt, listeners) {\n        // Pass through to manipulateListeners\n        return this.manipulateListeners(false, evt, listeners);\n    };\n\n    /**\n     * Removes listeners in bulk using the manipulateListeners method.\n     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.\n     * You can also pass it an event name and an array of listeners to be removed.\n     * You can also pass it a regular expression to remove the listeners from all events that match it.\n     *\n     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.\n     * @param {Function[]} [listeners] An optional array of listener functions to remove.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.removeListeners = function removeListeners(evt, listeners) {\n        // Pass through to manipulateListeners\n        return this.manipulateListeners(true, evt, listeners);\n    };\n\n    /**\n     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.\n     * The first argument will determine if the listeners are removed (true) or added (false).\n     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.\n     * You can also pass it an event name and an array of listeners to be added/removed.\n     * You can also pass it a regular expression to manipulate the listeners of all events that match it.\n     *\n     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.\n     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.\n     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {\n        var i;\n        var value;\n        var single = remove ? this.removeListener : this.addListener;\n        var multiple = remove ? this.removeListeners : this.addListeners;\n\n        // If evt is an object then pass each of its properties to this method\n        if (typeof evt === 'object' && !(evt instanceof RegExp)) {\n            for (i in evt) {\n                if (evt.hasOwnProperty(i) && (value = evt[i])) {\n                    // Pass the single listener straight through to the singular method\n                    if (typeof value === 'function') {\n                        single.call(this, i, value);\n                    }\n                    else {\n                        // Otherwise pass back to the multiple function\n                        multiple.call(this, i, value);\n                    }\n                }\n            }\n        }\n        else {\n            // So evt must be a string\n            // And listeners must be an array of listeners\n            // Loop over it and pass each one to the multiple method\n            i = listeners.length;\n            while (i--) {\n                single.call(this, evt, listeners[i]);\n            }\n        }\n\n        return this;\n    };\n\n    /**\n     * Removes all listeners from a specified event.\n     * If you do not specify an event then all listeners will be removed.\n     * That means every event will be emptied.\n     * You can also pass a regex to remove all events that match it.\n     *\n     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.removeEvent = function removeEvent(evt) {\n        var type = typeof evt;\n        var events = this._getEvents();\n        var key;\n\n        // Remove different things depending on the state of evt\n        if (type === 'string') {\n            // Remove all listeners for the specified event\n            delete events[evt];\n        }\n        else if (evt instanceof RegExp) {\n            // Remove all events matching the regex.\n            for (key in events) {\n                if (events.hasOwnProperty(key) && evt.test(key)) {\n                    delete events[key];\n                }\n            }\n        }\n        else {\n            // Remove all listeners in all events\n            delete this._events;\n        }\n\n        return this;\n    };\n\n    /**\n     * Alias of removeEvent.\n     *\n     * Added to mirror the node API.\n     */\n    proto.removeAllListeners = alias('removeEvent');\n\n    /**\n     * Emits an event of your choice.\n     * When emitted, every listener attached to that event will be executed.\n     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.\n     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.\n     * So they will not arrive within the array on the other side, they will be separate.\n     * You can also pass a regular expression to emit to all events that match it.\n     *\n     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.\n     * @param {Array} [args] Optional array of arguments to be passed to each listener.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.emitEvent = function emitEvent(evt, args) {\n        var listenersMap = this.getListenersAsObject(evt);\n        var listeners;\n        var listener;\n        var i;\n        var key;\n        var response;\n\n        for (key in listenersMap) {\n            if (listenersMap.hasOwnProperty(key)) {\n                listeners = listenersMap[key].slice(0);\n\n                for (i = 0; i < listeners.length; i++) {\n                    // If the listener returns true then it shall be removed from the event\n                    // The function is executed either with a basic call or an apply if there is an args array\n                    listener = listeners[i];\n\n                    if (listener.once === true) {\n                        this.removeListener(evt, listener.listener);\n                    }\n\n                    response = listener.listener.apply(this, args || []);\n\n                    if (response === this._getOnceReturnValue()) {\n                        this.removeListener(evt, listener.listener);\n                    }\n                }\n            }\n        }\n\n        return this;\n    };\n\n    /**\n     * Alias of emitEvent\n     */\n    proto.trigger = alias('emitEvent');\n\n    /**\n     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.\n     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.\n     *\n     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.\n     * @param {...*} Optional additional arguments to be passed to each listener.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.emit = function emit(evt) {\n        var args = Array.prototype.slice.call(arguments, 1);\n        return this.emitEvent(evt, args);\n    };\n\n    /**\n     * Sets the current value to check against when executing listeners. If a\n     * listeners return value matches the one set here then it will be removed\n     * after execution. This value defaults to true.\n     *\n     * @param {*} value The new value to check for when executing listeners.\n     * @return {Object} Current instance of EventEmitter for chaining.\n     */\n    proto.setOnceReturnValue = function setOnceReturnValue(value) {\n        this._onceReturnValue = value;\n        return this;\n    };\n\n    /**\n     * Fetches the current value to check against when executing listeners. If\n     * the listeners return value matches this one then it should be removed\n     * automatically. It will return true by default.\n     *\n     * @return {*|Boolean} The current value to check for or the default, true.\n     * @api private\n     */\n    proto._getOnceReturnValue = function _getOnceReturnValue() {\n        if (this.hasOwnProperty('_onceReturnValue')) {\n            return this._onceReturnValue;\n        }\n        else {\n            return true;\n        }\n    };\n\n    /**\n     * Fetches the events object and creates one if required.\n     *\n     * @return {Object} The events storage object.\n     * @api private\n     */\n    proto._getEvents = function _getEvents() {\n        return this._events || (this._events = {});\n    };\n\n    /**\n     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.\n     *\n     * @return {Function} Non conflicting EventEmitter class.\n     */\n    EventEmitter.noConflict = function noConflict() {\n        exports.EventEmitter = originalGlobalValue;\n        return EventEmitter;\n    };\n\n    // Expose the class either via AMD, CommonJS or the global object\n    if (typeof define === 'function' && define.amd) {\n        define(function () {\n            return EventEmitter;\n        });\n    }\n    else if (typeof module === 'object' && module.exports){\n        module.exports = EventEmitter;\n    }\n    else {\n        exports.EventEmitter = EventEmitter;\n    }\n}(typeof window !== 'undefined' ? window : this || {}));\n"

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Settings = function () {
  function Settings(loggerFunction) {
    _classCallCheck(this, Settings);

    /* localStorage may be disabled due to zero-quota issues (e.g. iPad in private browsing mode) */
    this._isLocalStorageEnabled = undefined;
    this.localStorageNamespace = 'comprodls.analytics';
    this.version = '1.0.0';
    if (loggerFunction) {
      this.loggerFunction = loggerFunction;
    }
  }

  /**
   * Purpose: To check if local storage is enabled in browser or not.
   * Input Parameter :none
   * Output : true or false.
   */


  _createClass(Settings, [{
    key: 'isLocalStorageEnabled',
    value: function isLocalStorageEnabled() {
      if (this._isLocalStorageEnabled) {
        return true;
      }
      if (typeof _isLocalStorageEnabled === 'undefined') {
        this._isLocalStorageEnabled = false;
        if (localStorage) {
          try {
            localStorage.setItem('_isLocalStorageEnabled', '?');
            localStorage.removeItem('_isLocalStorageEnabled');
            this._isLocalStorageEnabled = true;
          } catch (e) {}
        }
        return this._isLocalStorageEnabled;
      } else {
        return false;
      }
    }

    /**
     * Purpose: To set a value for corresponding key in localstorage
     * Input Parameter :key, value and callback function
     * Output : none
     */

  }, {
    key: 'putData',
    value: function putData(key, val, callback) {
      if (!this.isLocalStorageEnabled()) {
        if (callback) {
          callback();
        }
        return;
      }

      var value = '';
      try {
        value = JSON.stringify(val);
        localStorage.setItem(this.localStorageNamespace + '.' + key + '-' + this.version, value);
      } catch (err) {
        if (this.loggerFunction) {
          this.loggerFunction({
            key: key,
            dataSize: value.length,
            errorMessage: err.message,
            errorStack: err.stack,
            errorObject: JSON.stringify(err)
          }, 'XAPI_LOCAL_STORAGE;PUT_DATA_ERROR');
        }
        throw err;
      }

      if (callback) {
        callback();
      }
    }

    /**
     * Purpose: To get a value for corresponding key in localstorage
     * Input Parameter :key and callback function
     * Output : Value for the corresponding key.
     */

  }, {
    key: 'getData',
    value: function getData(key, callback) {
      if (!this.isLocalStorageEnabled()) {
        if (callback) {
          callback(null);
        }
        return;
      }

      var val = void 0;
      try {
        val = localStorage.getItem(this.localStorageNamespace + '.' + key + '-' + this.version);
      } catch (err) {
        if (this.loggerFunction) {
          this.loggerFunction({
            key: key,
            errorMessage: err.message,
            errorStack: err.stack,
            errorObject: JSON.stringify(err)
          }, 'XAPI_LOCAL_STORAGE;GET_DATA_ERROR');
        }
        throw err;
      }

      if (val) {
        callback(JSON.parse(val));
      } else {
        callback(null);
      }
    }

    /**
     * Purpose: To get values for all corresponding keys in localstorage
     * Input Parameter :keys and callback function
     * Output : Values for the corresponding keys.
     */

  }, {
    key: 'getMultipleData',
    value: function getMultipleData(keys, callback) {
      if (!this.isLocalStorageEnabled()) {
        if (callback) {
          callback({});
        }
        return;
      }

      var retVal = {};
      try {
        for (var i = 0; i < keys.length; i++) {
          if (localStorage.getItem(this.localStorageNamespace + '.' + keys[i] + '-' + this.version)) {
            retVal[keys[i]] = localStorage.getItem(this.localStorageNamespace + '.' + keys[i] + '-' + this.version);
          }
        }
      } catch (err) {
        if (this.loggerFunction) {
          this.loggerFunction({
            keys: keys,
            errorMessage: err.message,
            errorStack: err.stack,
            errorObject: JSON.stringify(err)
          }, 'XAPI_LOCAL_STORAGE;GET_MULTIPLE_DATA_ERROR');
        }
        throw err;
      }
      callback(retVal);
    }

    /**
     * Purpose: To remove all old version keys from localstorage.
     */

  }, {
    key: 'removeMultipleData',
    value: function removeMultipleData(callback) {
      if (!this.isLocalStorageEnabled()) {
        if (callback) {
          callback();
        }
        return;
      }
      var removeItems = [];
      try {
        for (var i = 0, len = localStorage.length; i < len; ++i) {
          var key = localStorage.key(i);
          if (key.indexOf(this.localStorageNamespace) !== -1) {
            var localstorageVersion = key.substring(key.lastIndexOf('-') + 1, key.length);
            if (localstorageVersion !== this.version) {
              removeItems.push(key);
            }
          }
        }
        for (var j = 0; j < removeItems.length; j++) {
          localStorage.removeItem(removeItems[j]);
        }
      } catch (err) {
        if (this.loggerFunction) {
          this.loggerFunction({
            errorMessage: err.message,
            errorStack: err.stack,
            errorObject: JSON.stringify(err)
          }, 'XAPI_LOCAL_STORAGE;REMOVE_MULTIPLE_DATA_ERROR');
        }
        throw err;
      }
      if (callback) {
        callback();
      }
    }

    /**
     *  Purpose: To find all keys matching a regex expression
     *  @param {String} query
     */

  }, {
    key: 'findMultipleData',
    value: function findMultipleData(query, callback) {
      if (!this.isLocalStorageEnabled()) {
        if (callback) {
          callback({});
        }
        return;
      }

      try {
        var testKey = new RegExp(this.localStorageNamespace + '.' + query + '-' + this.version);

        var results = [];
        for (var i in localStorage) {
          if (localStorage.hasOwnProperty(i)) {
            if (i.match(testKey)) {
              var value = JSON.parse(localStorage.getItem(i));
              results.push({ key: i, value: value });
            }
          }
        }
        return results;
      } catch (err) {
        if (this.loggerFunction) {
          this.loggerFunction({
            query: query,
            errorMessage: err.message,
            errorStack: err.stack,
            errorObject: JSON.stringify(err)
          }, 'XAPI_LOCAL_STORAGE;FIND_MULTIPLE_DATA_ERROR');
        }
        throw err;
      }
    }

    /**
     * Purpose: To remove a specific key from localStorage.
     */

  }, {
    key: 'removeData',
    value: function removeData(key, callback) {
      if (!this.isLocalStorageEnabled()) {
        if (callback) {
          callback();
        }
        return;
      }
      try {
        localStorage.removeItem(this.localStorageNamespace + '.' + key + '-' + this.version);
      } catch (err) {
        if (this.loggerFunction) {
          this.loggerFunction({
            key: key,
            errorMessage: err.message,
            errorStack: err.stack,
            errorObject: JSON.stringify(err)
          }, 'XAPI_LOCAL_STORAGE;REMOVE_DATA_ERROR');
        }
        throw err;
      }
      if (callback) {
        callback();
      }
    }
  }]);

  return Settings;
}();

exports.default = Settings;
module.exports = exports['default'];

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XAPIAnalytics = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $ */
/* global visibly */
/* global EventEmitter */
/* global nanoid */

var _localstorage = __webpack_require__(7);

var _localstorage2 = _interopRequireDefault(_localstorage);

var _sessionstorage = __webpack_require__(30);

var _sessionstorage2 = _interopRequireDefault(_sessionstorage);

var _helper = __webpack_require__(1);

var _helper2 = _interopRequireDefault(_helper);

__webpack_require__(2);

__webpack_require__(4);

__webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  XAPIAnalytics initialization Class. Provides public functions
 *  - postStatements()
 *  - postStatementsNoBatch()
 *  - postStatementsInBulkNoBatch()
 *  - flushStatements()
 *  - postState()
 *  - postStateNoBatch()
 *  - postStateInBulkNoBatch()
 *  - flushState()
 *  - flushStateAndStatements()
 *  - getState()
 *  - updateState()
 *  - deleteState()
 */

var XAPIAnalytics = function () {

    /**  XAPIAnalytics CONSTRUCTOR FUNCTION
     *   @constructor
     *   @param {Object} options -
     *          {String} serverRoutePrefix - serverRoutePrefix
     *          {String} spaceId - Space Id
     *          {String} productCode - Product Code - Mandatory for state
     *          {Boolean} isTestTypeProduct - Whether the product is test type - Optional
     *          {String} classId - Class ID - Optional
     *          {Boolean} isCBPClass - Whether the class is context-based - Optional
     *          {String} assignedPathId - Assignment ID - Optional
     *          {Object} userDetails - {orgId: '',extUserId: '',extEmail: '',userRole: ''}; - extUserId must
     *          {Array} userProgressAnalytics - [ {'item-code': 'a/b/c', __analytics: {}}, {}, ...]; - Updated UA JSON from DLS, must if statement batching methods are used
     *          {Function} postedCallback - Optional
     *          {Function} successCallback - Optional
     *          {Function} errorCallback - Optional
     *          {Function} previousStatementCallback - Optional
     *          {Function} getQueryParamsObj - Optional
     *          {Object} persistentState - Optional; Default false for all items
     *          {String} userAccountSessionKey - Optional; Default 'comprodls.nemo.userAccount'
     *   @param {Function} callback - To inform the container that constructor initiliazation is complete. - Optional
     */
    function XAPIAnalytics(options, callback) {
        _classCallCheck(this, XAPIAnalytics);

        if (options.serverRoutePrefix) {
            this.serverRoutePrefix = options.serverRoutePrefix + '/';
        } else {
            this.serverRoutePrefix = '/';
        }

        this.selectedProduct = options.productCode;

        if (options.isTestTypeProduct) {
            this.isTestTypeProduct = options.isTestTypeProduct;
        }

        if (options.spaceId) {
            this.spaceId = options.spaceId;
        }

        if (options.orgId) {
            this.orgId = options.orgId;
        }

        if (options.classId) {
            this.classId = options.classId;
        }

        if (options.isCBPClass) {
            this.isCBPClass = options.isCBPClass;
        }

        if (options.assignedPathId) {
            this.assignedPathId = options.assignedPathId;
        }

        if (options.userDetails) {
            this.userDetails = options.userDetails;
        } else this.userDetails = {};

        if (options.userAccountSessionKey) {
            this.userAccountSessionKey = options.userAccountSessionKey;
        } else this.userAccountSessionKey = 'comprodls.nemo.userAccount';

        if (options.userProgressAnalytics) {
            this.userProgressAnalytics = options.userProgressAnalytics;
        }

        if (options.postedCallback) {
            this.postedCallback = options.postedCallback;
        }

        if (options.successCallback) {
            this.successCallback = options.successCallback;
        }

        if (options.errorCallback) {
            this.errorCallback = options.errorCallback;
        }

        if (options.previousStatementCallback) {
            this.previousStatementCallback = options.previousStatementCallback;
        }

        if (options.getQueryParamsObj) {
            this.getQueryParamsObj = options.getQueryParamsObj;
        }

        if (options.persistentState) {
            this.persistentState = options.persistentState;
        } else {
            this.persistentState = {
                '*': false
            };
        }

        this.config = {
            'sendStatementInterval': 20,
            'sendStateInterval': 30
        };

        this.eventEmitter = new EventEmitter();
        this.networkCallsInProgress = 0;

        if (options.config) {
            $.extend(true, this.config, options.config);
        }

        this.settings = new _localstorage2.default(this.logInfoToBackend.bind(this));

        if (this.userDetails.extUserId && this.selectedProduct) {
            this.stateKey = 'activityState' + '-' + this.userDetails.extUserId + '-' + this.selectedProduct;
            this.persistentStateKey = 'persistentState' + '-' + this.userDetails.extUserId + '-' + this.selectedProduct;
            if (this.isCBPClass && this.classId) {
                this.stateKey += '-' + this.classId;
                this.persistentStateKey += '-' + this.classId;
            }
        }

        if (this.userDetails.extUserId) {
            this.primaryStatementKey = 'xapiStatement' + '-' + this.userDetails.extUserId + (this.selectedProduct ? '-' + this.selectedProduct : '');
            this.secondaryStatementKey = 'secondaryXapiStatement' + '-' + this.userDetails.extUserId + (this.selectedProduct ? '-' + this.selectedProduct : '');
            this.persistenceStatementKey = 'persistence' + '-' + this.userDetails.extUserId + (this.selectedProduct ? '-' + this.selectedProduct : '');
        }

        /** A unique xapiId is added to the statements for every new XAPIANalytics */
        this.xapiId = nanoid.nanoid(16);

        this.sessionSettings = new _sessionstorage2.default();

        /* Post Statements to LRS, from local storage if any present */
        this.clearAndPostPreviousStatementsBatch();

        this.addEventListnersOnInitialization();

        /** platformId is to identify unique browser tab. NOTE: performance.getEntriesByType('navigation') returns empty array in safari version < 15*/
        if (this.sessionSettings.getData('platformId') && performance.getEntriesByType('navigation')[0] && performance.getEntriesByType('navigation')[0].type === 'back_forward' && !this.sessionSettings.getData('navigatedOut') || !this.sessionSettings.getData('platformId')) {
            this.platformId = nanoid.nanoid(16);
            this.sessionSettings.putData('platformId', this.platformId);
        } else {
            this.platformId = this.sessionSettings.getData('platformId');
        }

        /** navigatedOut variable is set to true is sessionStorage when user navigate to some different page */
        this.sessionSettings.putData('navigatedOut', false);

        /** Inform the container that initialization is complete */
        if (callback) {
            callback();
        }
    }

    /** Function to store xapi statements in local storage and posts them after a threshold time.
     *  @param {Object} statementsArray - Statements array
     */


    _createClass(XAPIAnalytics, [{
        key: 'postStatements',
        value: function postStatements(statementsArray) {
            var _this = this;

            if (!this.statementInterval) {
                //setInterval to postStatements
                this.statementInterval = setInterval(function () {
                    _this.flushStatements(false, { notifyViaCallback: true }).catch(function (e) {
                        throw e;
                    });
                }, this.config.sendStatementInterval * 1000);

                visibly.onHidden(function () {
                    _this.flushStatements(false, { notifyViaCallback: true, keys: [_this.primaryStatementKey] }).catch(function (e) {
                        throw e;
                    });
                });
            }

            this.storeStatementInLocalStorage(statementsArray);
        }

        /** Function to post xAPI statements to API without any batching i.e not storing them in local storage.
         *  @param {Object} statementsArray - Statements array
         *  @param {Object} : notifyViaCallback - Optional, If true notify APP via callback provided, if any;
         *                    isSignedURLReq - Optional, if updated signed url req for audio path in statement;
         *                    subType - Optional - req if isSignedURLReq true;
         *                    submissionTypeId - req if isSignedURLReq true;
         *  @return {Promise}
         */

    }, {
        key: 'postStatementsNoBatch',
        value: function postStatementsNoBatch(statementsArray) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref$notifyViaCallbac = _ref.notifyViaCallback,
                notifyViaCallback = _ref$notifyViaCallbac === undefined ? false : _ref$notifyViaCallbac,
                _ref$isSignedURLReq = _ref.isSignedURLReq,
                isSignedURLReq = _ref$isSignedURLReq === undefined ? false : _ref$isSignedURLReq,
                subType = _ref.subType,
                submissionTypeId = _ref.submissionTypeId;

            var statementObject = _helper2.default.updateStatementObjectToPostToLRS(statementsArray, this.getStatementDataOptions());
            return this.postStatementsToLRS(statementObject, { notifyViaCallback: notifyViaCallback, isSignedURLReq: isSignedURLReq, subType: subType, submissionTypeId: submissionTypeId }).then(function (response) {
                return response;
            });
        }

        /** Function to validate and post xAPI statements to API in bulk without any batching i.e not storing them in local storage.
         *  @param {Object} statementsArray - Statements array
         *  @param {String} notifyViaCallback
         *  @return {Promise}
         */

    }, {
        key: 'postStatementsInBulkNoBatch',
        value: function postStatementsInBulkNoBatch(statementsArray) {
            var notifyViaCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var statementObject = _helper2.default.updateStatementObjectToPostToLRS(statementsArray, this.getStatementDataOptions());
            return this.validateStatementsSizeAndPostStatements(statementObject, { notifyViaCallback: notifyViaCallback });
        }

        /** Function to get all xAPI statements from local stoarage and post to API.
         * @param {Boolean} clearStatementInterval
         * @param {Object} notifyViaCallback - Boolean and keys - LS Keys Array
         * @return {Promise}
         */

    }, {
        key: 'flushStatements',
        value: function flushStatements(clearStatementInterval) {
            var _this2 = this;

            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref2$notifyViaCallba = _ref2.notifyViaCallback,
                notifyViaCallback = _ref2$notifyViaCallba === undefined ? false : _ref2$notifyViaCallba,
                _ref2$keys = _ref2.keys,
                keys = _ref2$keys === undefined ? [this.primaryStatementKey, this.persistenceStatementKey] : _ref2$keys;

            if (clearStatementInterval) {
                this.statementInterval = clearInterval(this.statementInterval);
            }

            return new Promise(function (resolve, reject) {
                var promises = [];
                keys.forEach(function (key) {
                    var statementObject = void 0;
                    _this2.settings.getData(key, function (data) {
                        if (data) {
                            statementObject = data;
                            if (key === _this2.primaryStatementKey) {
                                _this2.settings.removeData(_this2.primaryStatementKey);
                            }
                        }
                    });
                    if (statementObject) promises.push(_this2.validateStatementsSizeAndPostStatements(statementObject, { key: key, notifyViaCallback: notifyViaCallback }));
                });
                Promise.all(promises).then(function (res) {
                    return resolve(res);
                }).catch(function (error) {
                    return reject(error);
                });
            });
        }

        /** Function to store user state in local storage and post after a time interval.
         *  State can be either persistent or user app state;
         *  persistentState (via constructor) needs to be intialized for persistent state storage
         *  @param {String} itemCode - Item Code
         *  @param {Object} stateObject - State object
         *  @param {Object} : documentId and action - Optional; For Persistent storage
         */

    }, {
        key: 'postState',
        value: function postState(itemCode, stateObject) {
            var _this3 = this;

            var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref3$documentId = _ref3.documentId,
                documentId = _ref3$documentId === undefined ? 'lastKnown' : _ref3$documentId,
                _ref3$action = _ref3.action,
                action = _ref3$action === undefined ? 'create' : _ref3$action;

            if (!this.stateInterval) {
                //setInterval to postState
                this.stateInterval = setInterval(function () {
                    _this3.flushState(false, { notifyViaCallback: true }).catch(function (e) {
                        throw e;
                    });
                }, this.config.sendStateInterval * 1000);

                visibly.onHidden(function () {
                    _this3.flushState(true, { notifyViaCallback: true }).catch(function (e) {
                        throw e;
                    });
                });
            }

            this.updateStateInLocalStorage(itemCode, { stateObject: stateObject, documentId: documentId, action: action });
        }

        /** Function to post state to API without any batching i.e not storing them in local storage.
         *  @param {String} itemCode - item code
         *  @param {Object} stateObject
         *  @param {Object} : notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         *                    documentId and action - Optional; For Persistent storage
         *                    userId - Optional, DLS User Id whose state to be posted; Not supported for persistent storage;
         *                    extUserId - Optional; External User Id of user whose state to be posted.
         *                    updateState - Optional; If true, update state instead of creating new
         *                    isSignedURLReq - Optional, if updated signed url req for audio path in state;
         *                    subType - Optional - req if isSignedURLReq true;
         *                    submissionTypeId - req if isSignedURLReq true;
         *  @return {Promise}
         */

    }, {
        key: 'postStateNoBatch',
        value: function postStateNoBatch(itemCode, stateObject) {
            var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                userId = _ref4.userId,
                _ref4$documentId = _ref4.documentId,
                documentId = _ref4$documentId === undefined ? 'lastKnown' : _ref4$documentId,
                _ref4$action = _ref4.action,
                action = _ref4$action === undefined ? 'create' : _ref4$action,
                _ref4$notifyViaCallba = _ref4.notifyViaCallback,
                notifyViaCallback = _ref4$notifyViaCallba === undefined ? false : _ref4$notifyViaCallba,
                extUserId = _ref4.extUserId,
                updateState = _ref4.updateState,
                _ref4$isSignedURLReq = _ref4.isSignedURLReq,
                isSignedURLReq = _ref4$isSignedURLReq === undefined ? false : _ref4$isSignedURLReq,
                subType = _ref4.subType,
                submissionTypeId = _ref4.submissionTypeId;

            /* Safe check - remove any state, if present in local storage */
            this.updateStateInLocalStorage(itemCode, { documentId: documentId, isStateToBeCleared: true });

            if (this.isPersistentState(itemCode)) {
                if (userId) return Promise.reject('error');

                var statementObject = this.createStatementObjectForState({ itemCode: itemCode, stateObject: stateObject, documentId: documentId, action: action });
                return this.postStatementsToLRS(statementObject, { notifyViaCallback: notifyViaCallback, notifyCallbackType: 'postState', isSignedURLReq: isSignedURLReq, subType: subType, submissionTypeId: submissionTypeId }).then(function (response) {
                    return response[itemCode + '-' + documentId + '-' + action];
                });
            } else {
                /* Post state to LRS */
                return this.postStateToLRS(itemCode, stateObject, { userId: userId, notifyViaCallback: notifyViaCallback, extUserId: extUserId, updateState: updateState, isSignedURLReq: isSignedURLReq, subType: subType, submissionTypeId: submissionTypeId }).then(function (response) {
                    return response;
                });
            }
        }

        /** Function to batch and post state in bulk to API without any batching i.e not storing them in local storage.
         *  @param {Object} stateItemMap - {itemCode: stateObj, itemCode-documentId-action: stateObj}
         *  @param {Boolean} : notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         *  @return {Promise}
         */

    }, {
        key: 'postStateInBulkNoBatch',
        value: async function postStateInBulkNoBatch(stateItemMap) {
            var _this4 = this;

            var notifyViaCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var entitiesArr = [],
                promises = [];
            Object.keys(stateItemMap).forEach(function (key) {
                var temp = key.split('-');
                var itemCode = temp[0];
                var documentId = temp[1] ? temp[1] : 'lastKnown';
                _this4.updateStateInLocalStorage(itemCode, { documentId: documentId, isStateToBeCleared: true });
                if (_this4.isPersistentState(itemCode)) {
                    var action = temp[2] ? temp[2] : 'create';
                    entitiesArr.push.apply(entitiesArr, _toConsumableArray(_this4.createStatementEntitiesForState(itemCode, stateItemMap[key], documentId, action)));
                } else {
                    promises.push(_this4.postStateToLRS(itemCode, stateItemMap[key], { notifyViaCallback: notifyViaCallback }));
                }
            });

            if (entitiesArr.length > 0) {
                var statement = this.createStatementObjectForState({ entitiesArr: entitiesArr });
                promises.push(this.validateStatementsSizeAndPostStatements(statement, { notifyViaCallback: notifyViaCallback, notifyCallbackType: 'postState' }));
            }

            var index = 0,
                results = [];
            while (index < promises.length) {
                var promisesBatch = promises.slice(index, index + 5);
                results = [].concat(_toConsumableArray(results), _toConsumableArray((await Promise.all(promisesBatch))));
                index += 5;
            }
            return results;
        }

        /** Function to get all state from local stoarage and post to API.
         * @param {Boolean} clearStateInterval
         * @param {Object} : filterItemCode - Optional, State not to be updated for completed item; notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         * @return {Promise}
         */

    }, {
        key: 'flushState',
        value: function flushState(clearStateInterval) {
            var _this5 = this;

            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                filterItemCode = _ref5.filterItemCode,
                _ref5$notifyViaCallba = _ref5.notifyViaCallback,
                notifyViaCallback = _ref5$notifyViaCallba === undefined ? false : _ref5$notifyViaCallba;

            /* Clear state interval, if required */
            if (clearStateInterval) {
                this.stateInterval = clearInterval(this.stateInterval);
            }

            /* Get all state keys form local storage */
            return new Promise(function (resolve, reject) {
                var promises = [];

                var query = _this5.stateKey + '-' + '(.*)';
                var results = _this5.settings.findMultipleData(query);
                results.forEach(function (state) {
                    var temp = state.key.split('-');
                    var item = temp[temp.length - 2];
                    /* Dont post state for filter [completed] item code */
                    if (item !== filterItemCode) {
                        promises.push(_this5.postStateToLRS(item, state.value, { notifyViaCallback: notifyViaCallback }));
                    }
                    localStorage.removeItem(state.key);
                });

                /* Persistent Storage State */
                var persistentQuery = _this5.persistentStateKey + '-' + '(.*)';
                var persistentResults = _this5.settings.findMultipleData(persistentQuery);

                var entitiesArr = [];
                persistentResults.forEach(function (item) {
                    var temp = item.key.split('-');
                    var itemCode = temp[temp.length - 2];
                    Object.keys(item.value).forEach(function (key) {
                        var temp1 = key.split('-');
                        entitiesArr.push.apply(entitiesArr, _toConsumableArray(_this5.createStatementEntitiesForState(itemCode, item.value[key], temp1[0], temp1[1])));
                    });
                    localStorage.removeItem(item.key);
                });

                if (entitiesArr.length > 0) {
                    var statement = _this5.createStatementObjectForState({ entitiesArr: entitiesArr });
                    promises.push(_this5.validateStatementsSizeAndPostStatements(statement, { notifyViaCallback: notifyViaCallback, notifyCallbackType: 'postState' }));
                }

                Promise.all(promises).then(function () {
                    return resolve('success');
                });
            });
        }

        /**
         * Function to get all state and statements from local storage and post to API.
         * @param {Boolean} notifyViaCallback
         * @return {Promise}
         */

    }, {
        key: 'flushStateAndStatements',
        value: function flushStateAndStatements() {
            var _this6 = this;

            var notifyViaCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return Promise.all([this.flushStatements(true, { notifyViaCallback: notifyViaCallback }), this.flushState(true, { notifyViaCallback: notifyViaCallback })]).then(function (response) {
                /* If no network calls in progress resolve response */
                if (_this6.networkCallsInProgress === 0) {
                    return Promise.resolve(response);
                }
                /* Max promise resolve time out */
                var maxPromiseResolveWaitTime = 5000;
                var promiseResolveTimeOut = void 0;
                return new Promise(function (resolve, reject) {
                    var res = [];
                    var listener = function listener(data) {
                        if (data) res.push(data);
                        if (_this6.networkCallsInProgress === 0) {
                            clearTimeout(promiseResolveTimeOut);
                            resolve(res);
                            return true;
                        }
                    };
                    _this6.eventEmitter.addListener('networkCallResponse', listener);
                    /* resolve promise max in 5 secs if not already resolved */
                    promiseResolveTimeOut = setTimeout(function () {
                        _this6.eventEmitter.removeListener('networkCallResponse', listener);
                        resolve('timeout');
                    }, maxPromiseResolveWaitTime);
                });
            }).catch(function (error) {
                return Promise.reject(error);
            });
        }

        /** Function to get user progress state.
         *  State can either be fetched via persistent or user app storage;
         *  persistentState (via constructor) needs to be intialized for persistent state fetch
         *  @param {String} itemCode - Item Code
         *  @param {Object} : userId - Optional, DLS User Id whose state to be fetched; Not Supported for persistent storage;
         *                    notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         *                    documentId: Optional, for persistent storage;
         *                    extUserId - Optional; External User Id of user whose state to be fetched.
         *                    isSignedURLReq - Optional, if updated signed url req for audio path in state;
         *                    subType - Optional - req if isSignedURLReq true;
         *                    submissionTypeId - req if isSignedURLReq true;
         *  @return {Promise}
         */

    }, {
        key: 'getState',
        value: async function getState(itemCode) {
            var _this7 = this;

            var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                userId = _ref6.userId,
                _ref6$documentId = _ref6.documentId,
                documentId = _ref6$documentId === undefined ? 'lastKnown' : _ref6$documentId,
                _ref6$notifyViaCallba = _ref6.notifyViaCallback,
                notifyViaCallback = _ref6$notifyViaCallba === undefined ? false : _ref6$notifyViaCallba,
                extUserId = _ref6.extUserId,
                _ref6$isSignedURLReq = _ref6.isSignedURLReq,
                isSignedURLReq = _ref6$isSignedURLReq === undefined ? false : _ref6$isSignedURLReq,
                subType = _ref6.subType,
                submissionTypeId = _ref6.submissionTypeId;

            var selectedItem = encodeURIComponent(itemCode);

            var url = this.serverRoutePrefix + 'api/user/product/progress/state/' + this.selectedProduct + '/' + selectedItem;
            url += await this.getQueryParams();

            var additionalParameters = {};

            if (this.spaceId) {
                additionalParameters.spaceid = this.spaceId;
            }

            if (this.orgId) {
                additionalParameters.orgId = this.orgId;
            }

            if (this.classId) {
                additionalParameters.classid = this.classId;
            }

            if (this.isCBPClass) {
                additionalParameters.isCBPClass = this.isCBPClass;
            }

            if (userId) {
                additionalParameters.userid = userId;
            }

            if (isSignedURLReq) {
                additionalParameters.isSignedURLReq = isSignedURLReq;
                if (subType) additionalParameters.subType = subType;
                if (submissionTypeId) additionalParameters.submissionTypeId = submissionTypeId;
            }

            if (extUserId) {
                additionalParameters.extUserId = extUserId;
            }

            if (this.isPersistentState(itemCode)) {
                /* Persistent state cannot be fetched for another user */
                if (userId) return Promise.reject('error');
                additionalParameters.documentId = documentId;
            }

            var getStateSuccess = function getStateSuccess(response) {
                if (notifyViaCallback && _this7.successCallback) _this7.successCallback('getState', response);
                return response;
            };

            var getStateError = async function getStateError(error) {
                await _this7.handleAjaxError(error, 'GET', 'getState', notifyViaCallback);
            };

            /* Notify app if state call sent */
            if (notifyViaCallback && this.postedCallback) this.postedCallback('getState', { url: url, additionalParameters: additionalParameters });

            return _helper2.default.sendAjaxRequest(url, getStateSuccess, getStateError, 'GET', { userId: this.userDetails.extUserId }, additionalParameters);
        }

        /** Function to update user progress state.
         *  State can either be persistent or user app;
         *  persistentState (via constructor) needs to be intialized for persistent state
         *  @param {String} itemCode - Item Code
         *  @param {Object} stateObject - State object
         *  @param {Object} : userId - Optional, DLS User Id whose state to be updated; Not Supported for persistent storage
         *                    notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         *                    documentId - Optional; For Persistent storage
         *                    extUserId - Optional; External User Id of user whose state to be updated.
         *                    updateState - Optional; If true, update state instead of creating new
         *  @return {Promise}
         */

    }, {
        key: 'updateState',
        value: function updateState(itemCode, stateObject) {
            var _this8 = this;

            var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                userId = _ref7.userId,
                _ref7$documentId = _ref7.documentId,
                documentId = _ref7$documentId === undefined ? 'lastKnown' : _ref7$documentId,
                _ref7$notifyViaCallba = _ref7.notifyViaCallback,
                notifyViaCallback = _ref7$notifyViaCallba === undefined ? false : _ref7$notifyViaCallba,
                extUserId = _ref7.extUserId,
                _updateState = _ref7.updateState;

            if (this.isPersistentState(itemCode)) {
                if (userId) return Promise.reject('error');
            }

            return this.getState(itemCode, { userId: userId, notifyViaCallback: notifyViaCallback, documentId: documentId, extUserId: extUserId }).then(function (response) {
                Object.assign(response, stateObject);
                return _this8.postStateNoBatch(itemCode, response, { documentId: documentId, action: 'update', userId: userId, notifyViaCallback: notifyViaCallback, extUserId: extUserId, updateState: _updateState });
            }).catch(function (error) {
                throw error;
            });
        }

        /** Function to delete user progress state.
         *  State can either be deleted via persistent or user app storage;
         *  persistentState (via constructor) needs to be intialized for persistent state delete
         *  @param {String} itemCode - Item Code
         *  @param {Object} : userId - Optional, DLS User Id whose state to be deleted; Not Supported for persistent storage
         *                    documentId - Optional; For Persistent storage
         *                    notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         *                    extUserId - Optional; External User Id of user whose state to be deleted.
         *  @return {Promise}
         */

    }, {
        key: 'deleteState',
        value: async function deleteState(itemCode) {
            var _this9 = this;

            var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                userId = _ref8.userId,
                _ref8$documentId = _ref8.documentId,
                documentId = _ref8$documentId === undefined ? 'lastKnown' : _ref8$documentId,
                _ref8$notifyViaCallba = _ref8.notifyViaCallback,
                notifyViaCallback = _ref8$notifyViaCallba === undefined ? false : _ref8$notifyViaCallba,
                extUserId = _ref8.extUserId;

            if (this.isPersistentState(itemCode)) {
                return this.postStateNoBatch(itemCode, {}, { userId: userId, documentId: documentId, action: 'delete', notifyViaCallback: notifyViaCallback });
            }

            var selectedItem = encodeURIComponent(itemCode);

            var url = this.serverRoutePrefix + 'api/user/product/progress/state/' + this.selectedProduct + '/' + selectedItem;
            url += await this.getQueryParams();

            var additionalParameters = {};

            if (this.spaceId) {
                additionalParameters.spaceid = this.spaceId;
            }

            if (this.orgId) {
                additionalParameters.orgId = this.orgId;
            }

            if (this.classId) {
                additionalParameters.classid = this.classId;
            }

            if (this.isCBPClass) {
                additionalParameters.isCBPClass = this.isCBPClass;
            }

            if (userId) {
                additionalParameters.userid = userId;
            }

            if (this.isTestTypeProduct) {
                additionalParameters.isTestTypeProduct = this.isTestTypeProduct;
            }

            if (extUserId) {
                additionalParameters.extUserId = extUserId;
            }

            var data = { queryParameters: additionalParameters };

            var deleteStateSuccess = function deleteStateSuccess(response) {
                if (notifyViaCallback && _this9.successCallback) _this9.successCallback('deleteState', response);
                return response;
            };

            var deleteStateError = async function deleteStateError(error) {
                await _this9.handleAjaxError(error, 'DELETE', 'deleteState', notifyViaCallback);
            };

            /* Notify app if state call sent */
            if (notifyViaCallback && this.postedCallback) this.postedCallback('deleteState', { url: url, additionalParameters: additionalParameters });

            return _helper2.default.sendAjaxRequest(url, deleteStateSuccess, deleteStateError, 'DELETE', { userId: this.userDetails.extUserId }, data);
        }

        /****************************** INTERNAL FUNCTIONS *******************************
         *********************************************************************************/

        /* Function to post any existing statements (from previous product launch) present in local storage to DLS */

    }, {
        key: 'clearAndPostPreviousStatementsBatch',
        value: function clearAndPostPreviousStatementsBatch() {
            var _this10 = this;

            /* Post any statements directly to DLS [except attempted/completed] if present in the primary statements map in local storage */
            var primaryStatementObject = void 0;
            this.settings.getData(this.primaryStatementKey, function (data) {
                if (data) {
                    primaryStatementObject = data;
                    _this10.settings.removeData(_this10.primaryStatementKey);
                }
            });

            if (primaryStatementObject) {
                /* Object containing statements to be posted to DLS from the primary statements map */
                var statementsToBePosted = JSON.parse(JSON.stringify(primaryStatementObject));
                statementsToBePosted.entities = [];

                primaryStatementObject.entities.forEach(function (statement) {
                    statementsToBePosted.entities.push(statement);
                });

                /* Post selected statements to DLS from the primary statements map */
                if (statementsToBePosted.entities.length > 0) {
                    this.logInfoToBackend({
                        affectedLOs: statementsToBePosted.entities.map(function (s) {
                            return { 'item-code': s['item-code'], verb: s.verb, timestamp: s.timestamp };
                        }),
                        ua: statementsToBePosted.platform.ua
                    }, 'TYPE=CONTAINER_ERROR_RECOVERY, Previous Primary Statements Batch Posted').catch(function (e) {
                        throw e;
                    });
                    this.validateStatementsSizeAndPostStatements(statementsToBePosted).catch(function (e) {
                        throw e;
                    });
                }
            }

            /* Get and Remove all 'attempted' statements present in the secondary statements map in local storage */
            var secondaryStatementObject = void 0;
            this.settings.getData(this.secondaryStatementKey, function (data) {
                if (data) {
                    secondaryStatementObject = data;
                    _this10.settings.removeData(_this10.secondaryStatementKey);
                }
            });

            if (secondaryStatementObject) {
                /* Object containing statements to be posted to DLS from the secondary statements map */
                var _statementsToBePosted = JSON.parse(JSON.stringify(secondaryStatementObject));
                _statementsToBePosted.entities = [];

                /* If user analytics passed by APP, update the status of all the attempted statements */
                if (this.userProgressAnalytics) {
                    secondaryStatementObject.entities.forEach(function (statement) {
                        var itemObject = _this10.userProgressAnalytics.find(function (item) {
                            return item['item-code'] === statement['item-code'];
                        });
                        /* Post statement if the activity is in-progress and was neither launched or completed afterwards [multi-device scenarios] */
                        if (itemObject && itemObject.__analytics && itemObject.__analytics.status === 'in_complete' && itemObject.__analytics.lastLaunched < statement.timestamp && (!itemObject.__analytics.completedOnce || itemObject.__analytics.completedLastDate < statement.timestamp)) {
                            _statementsToBePosted.entities.push(statement);
                            /* Post completed statement */
                            var completedStatement = JSON.parse(JSON.stringify(statement));
                            completedStatement.verb = 'completed';
                            delete completedStatement.timespent;
                            _statementsToBePosted.entities.push(completedStatement);
                            /* Update status */
                            if (_helper2.default.isSyncingAllowed(_statementsToBePosted.classid, _this10.classId, _this10.isCBPClass, _this10.isTestTypeProduct)) {
                                itemObject.__analytics.status = 'completed';
                            }
                        }
                    });
                }

                /* Post selected statements to DLS from the secondary statements map */
                if (_statementsToBePosted.entities.length > 0) {
                    this.logInfoToBackend({
                        affectedLOs: _statementsToBePosted.entities.map(function (s) {
                            return { 'item-code': s['item-code'], verb: s.verb, timestamp: s.timestamp };
                        }),
                        ua: _statementsToBePosted.platform.ua
                    }, 'TYPE=CONTAINER_ERROR_RECOVERY, Previous Secondary Statements Batch Posted').catch(function (e) {
                        throw e;
                    });
                    this.validateStatementsSizeAndPostStatements(_statementsToBePosted).catch(function (e) {
                        throw e;
                    });
                }
            }

            /* Post persistence map data to DLS */
            var persistenceStatementObject = void 0;
            this.settings.getData(this.persistenceStatementKey, function (data) {
                if (data) {
                    persistenceStatementObject = data;
                }
            });
            if (persistenceStatementObject) {
                /* Notify app if previous statetment batch present */
                if (this.previousStatementCallback) this.previousStatementCallback(persistenceStatementObject);
                this.validateStatementsSizeAndPostStatements(persistenceStatementObject, { key: this.persistenceStatementKey, notifyViaCallback: true }).catch(function (e) {
                    throw e;
                });
            }
        }

        /** Function to post statement to LRS - functions executes after a threshold time, it gets statement from local storage and posts it
         *  @param {Object} statement - Statements Object - If empty then get from local storage, if any.
         *  @param {Object} : key - LS Key Name;
         *                    notifyViaCallback - If true notify APP via callback provided, if any;
         *                    notifyCallbackType - Optional; req if persistentState posted;
         *                    isSignedURLReq - Optional, if updated signed url req for audio path in statements;
         *                    subType - Optional - req if isSignedURLReq true;
         *                    submissionTypeId - req if isSignedURLReq true;
         */

    }, {
        key: 'postStatementsToLRS',
        value: async function postStatementsToLRS(statementObject) {
            var _this11 = this;

            var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                key = _ref9.key,
                _ref9$notifyCallbackT = _ref9.notifyCallbackType,
                notifyCallbackType = _ref9$notifyCallbackT === undefined ? 'postStatements' : _ref9$notifyCallbackT,
                _ref9$notifyViaCallba = _ref9.notifyViaCallback,
                notifyViaCallback = _ref9$notifyViaCallba === undefined ? false : _ref9$notifyViaCallba,
                _ref9$isSignedURLReq = _ref9.isSignedURLReq,
                isSignedURLReq = _ref9$isSignedURLReq === undefined ? false : _ref9$isSignedURLReq,
                subType = _ref9.subType,
                submissionTypeId = _ref9.submissionTypeId;

            if (statementObject) {
                var url = this.serverRoutePrefix + 'api/xapi-statements/';
                url += await this.getQueryParams();

                var additionalParameters = {};

                if (statementObject.space_key) {
                    additionalParameters.spaceid = statementObject.space_key;
                }

                if (isSignedURLReq) {
                    additionalParameters.isSignedURLReq = isSignedURLReq;
                    if (subType) additionalParameters.subType = subType;
                    if (submissionTypeId) additionalParameters.submissionTypeId = submissionTypeId;
                }

                var data = { statementObject: JSON.stringify(statementObject), queryParameters: additionalParameters };

                var postStatementSuccess = function postStatementSuccess(response) {
                    _this11.networkCallsInProgress--;
                    /* Delete statements from local storage when success received */
                    if (key) _this11.deleteSuccessStatementsFromMap(response, key);
                    /* Update statement object back to state if persistent state post call */
                    if (notifyCallbackType === 'postState') response = _this11.createStateObjectFromStatement(response);
                    _this11.eventEmitter.emitEvent('networkCallResponse', [response]);
                    /* Notify app if callback provided */
                    if (notifyViaCallback && _this11.successCallback) _this11.successCallback(notifyCallbackType, response);
                    return response;
                };

                var postStatementError = async function postStatementError(error) {
                    await _this11.handleAjaxError(error, 'POST', notifyCallbackType, notifyViaCallback, { url: url, data: data, successHandler: postStatementSuccess, errorHandler: postStatementError });
                };

                /* Notify app if statetment call sent */
                var notifyData = JSON.parse(JSON.stringify(statementObject));
                /* Update statement object back to state if persistent state post call */
                if (notifyCallbackType === 'postState') notifyData = this.createStateObjectFromStatement(notifyData);
                if (notifyViaCallback && this.postedCallback) this.postedCallback(notifyCallbackType, notifyData);

                this.networkCallsInProgress++;
                return _helper2.default.sendAjaxRequest(url, postStatementSuccess, postStatementError, 'POST', { userId: this.userDetails.extUserId }, data);
            } else {
                return Promise.resolve('success');
            }
        }

        /* Function to post statements to LRS, after validating statement size */

    }, {
        key: 'validateStatementsSizeAndPostStatements',
        value: async function validateStatementsSizeAndPostStatements(statementObject) {
            var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                key = _ref10.key,
                notifyCallbackType = _ref10.notifyCallbackType,
                _ref10$notifyViaCallb = _ref10.notifyViaCallback,
                notifyViaCallback = _ref10$notifyViaCallb === undefined ? false : _ref10$notifyViaCallb;

            var statementsArr = this.validateStatementSize(statementObject);
            if (statementsArr.length > 1) {
                this.networkCallsInProgress += statementsArr.length;
                // Log Info to Backend
                this.logInfoToBackend({
                    affectedLOs: statementObject.entities.map(function (s) {
                        return { 'item-code': s['item-code'], verb: s.verb, timestamp: s.timestamp };
                    }),
                    ua: statementObject.platform.ua
                }, 'TYPE=CONTAINER_STATEMENTS_SPLIT, Statement Object Split into multiple statetments').catch(function (e) {
                    throw e;
                });
            }

            try {
                var res = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = statementsArr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var statement = _step.value;

                        res.push((await this.postStatementsToLRS(statement, { key: key, notifyViaCallback: notifyViaCallback, notifyCallbackType: notifyCallbackType })));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (statementsArr.length > 1) {
                    this.networkCallsInProgress -= statementsArr.length;
                    this.eventEmitter.emitEvent('networkCallResponse');
                }

                return this.mergeStatementsResponse(res, notifyCallbackType);
            } catch (err) {
                if (statementsArr.length > 1) {
                    this.networkCallsInProgress -= statementsArr.length;
                    this.eventEmitter.emitEvent('networkCallResponse');
                }
                throw err;
            }
        }

        /** Function to check statement size shoud not be greater than 2 MB [To prevent API Side Fails]
         *  AND statement entities length not be greater than 100
         *  If statement size or length is greater than split the statement entities into multiple statements object
         */

    }, {
        key: 'validateStatementSize',
        value: function validateStatementSize(statements) {
            var size = new TextEncoder().encode(JSON.stringify(statements)).length;
            var entitiesLength = statements.entities.length;
            if (size / 1024 / 1024 > 2 || entitiesLength > 100) {
                if (entitiesLength === 1) return [statements];

                var index = Math.floor(entitiesLength / 2);

                var leftCopy = JSON.parse(JSON.stringify(statements));
                leftCopy.entities = statements.entities.slice(0, index);

                var rightCopy = JSON.parse(JSON.stringify(statements));
                rightCopy.entities = statements.entities.slice(index, entitiesLength);

                return [].concat(_toConsumableArray(this.validateStatementSize(leftCopy)), _toConsumableArray(this.validateStatementSize(rightCopy)));
            } else return [statements];
        }

        /* Function to merge multiple statements entities response */

    }, {
        key: 'mergeStatementsResponse',
        value: function mergeStatementsResponse(response, notifyCallbackType) {
            if (response.length > 1) {
                if (notifyCallbackType === 'postState') {
                    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(response)));
                }
                var mergedResponse = response.shift();
                response.forEach(function (res) {
                    mergedResponse.entities = [].concat(_toConsumableArray(mergedResponse.entities), _toConsumableArray(res.entities));
                });
                return mergedResponse;
            } else return response[0];
        }

        /** Function to store statement in local storage, It first checks is any statements present in local storage, if yes then merge new statements into it.
         *  @param {Array} statementsArray
         */

    }, {
        key: 'storeStatementInLocalStorage',
        value: function storeStatementInLocalStorage(statementsArray) {
            var _statementData$entiti;

            var options = this.getStatementDataOptions();
            options.isStatementToBeStoredInLocalStorage = true;

            var _Utils$updateStatemen = _helper2.default.updateStatementObjectToPostToLRS(statementsArray, options),
                _Utils$updateStatemen2 = _slicedToArray(_Utils$updateStatemen, 2),
                entitiesArr = _Utils$updateStatemen2[0],
                verbsHash = _Utils$updateStatemen2[1];

            var key = this.primaryStatementKey;
            /* Store in persistence local storage */
            if (verbsHash['annotated'] || verbsHash['settings-updated']) {
                key = this.persistenceStatementKey;
            }

            var statementData = void 0;
            this.settings.getData(key, function (data) {
                if (data) {
                    statementData = data;
                }
            });

            if ($.isEmptyObject(statementData)) {
                statementData = _helper2.default.createStatementObject(statementsArray, this.getStatementDataOptions());
            }

            (_statementData$entiti = statementData.entities).push.apply(_statementData$entiti, _toConsumableArray(entitiesArr));

            if (key === this.primaryStatementKey) {
                this.updateSecondaryStatementMap(statementData);
                if (verbsHash['attempted'] || verbsHash['completed'] || verbsHash['closed']) {
                    this.settings.removeData(key);
                    this.validateStatementsSizeAndPostStatements(statementData, { key: key, notifyViaCallback: true }).catch(function (e) {
                        throw e;
                    });
                    this.statementInterval = clearInterval(this.statementInterval);
                    /* If completed statement present then update state for that item to latest timestamp */
                    if (this.selectedProduct) {
                        var attemptedStatement = verbsHash['attempted'] && statementData.entities.find(function (statement) {
                            return statement.verb === 'attempted' && statement['item-code'];
                        });
                        if (attemptedStatement) {
                            this.logInfoToBackend({ itemCode: attemptedStatement['item-code'] }, 'TYPE=ACTIVITY_COMPLETION;XAPIAnalytics').catch(function (e) {
                                throw e;
                            });
                        }
                        var completedStatement = void 0;
                        if (verbsHash['completed']) completedStatement = statementData.entities.find(function (statement) {
                            return statement.verb === 'completed' && statement['item-code'];
                        });
                        /* Clear user state if persistent state is not being used for this item */
                        if (completedStatement && !this.isPersistentState(completedStatement['item-code'])) {
                            this.flushState(true, { filterItemCode: completedStatement['item-code'], notifyViaCallback: true }).catch(function (e) {
                                throw e;
                            });
                            var stateObj = { timestamp: new Date().getTime() };
                            this.postStateToLRS(completedStatement['item-code'], stateObj, { notifyViaCallback: true }).catch(function (e) {
                                throw e;
                            });
                        } else {
                            this.flushState(true, { notifyViaCallback: true }).catch(function (e) {
                                throw e;
                            });
                        }
                    }
                    return;
                }
            }

            /* Store data in local storage */
            this.settings.putData(key, statementData);
        }

        /** Function to update statement in secondary statements map in local storage
         *  @param {Object} statementObject
         */

    }, {
        key: 'updateSecondaryStatementMap',
        value: function updateSecondaryStatementMap(statementObject) {
            var secondaryStatementObject = void 0;
            this.settings.getData(this.secondaryStatementKey, function (data) {
                if (data) {
                    secondaryStatementObject = data;
                }
            });

            /* If any attempted statements present for the item launched then delete the same */
            if (secondaryStatementObject && secondaryStatementObject.entities.length > 0) {
                var launchedStatements = statementObject.entities.filter(function (statement) {
                    return statement.verb === 'launched' && statement['item-code'];
                });
                if (launchedStatements) {
                    launchedStatements.forEach(function (statement) {
                        var statementIndex = secondaryStatementObject.entities.findIndex(function (s1) {
                            return s1['item-code'] === statement['item-code'];
                        });
                        if (statementIndex !== -1) {
                            secondaryStatementObject.entities.splice(statementIndex, 1);
                        }
                    });
                }
            }

            /* Create secondary statement object */
            if (!secondaryStatementObject) {
                secondaryStatementObject = JSON.parse(JSON.stringify(statementObject));
                secondaryStatementObject.entities = [];
            }

            /* Update secondary statement map with the attempted statements generated */
            var attemptedStatements = statementObject.entities.filter(function (statement) {
                return statement.verb === 'attempted' && statement['item-code'] && statement.xapi !== false;
            });
            if (attemptedStatements) {
                attemptedStatements.forEach(function (statement) {
                    /* Safe check - If an attempted statement already present for this item code then delete it */
                    var statementIndex = secondaryStatementObject.entities.findIndex(function (s1) {
                        return s1['item-code'] === statement['item-code'];
                    });
                    if (statementIndex !== -1) {
                        secondaryStatementObject.entities.splice(statementIndex, 1);
                    }
                    /* Update secondary statements map with the attempted statements while mainiting the size of 5 */
                    if (secondaryStatementObject.entities.length >= 5) secondaryStatementObject.entities.shift();
                    secondaryStatementObject.entities.push(statement);
                });
            }

            /* Update secondary statements map in local storage */
            if (secondaryStatementObject && secondaryStatementObject.entities.length > 0) {
                this.settings.putData(this.secondaryStatementKey, secondaryStatementObject);
            } else this.settings.removeData(this.secondaryStatementKey);
        }

        /** Function to delete statement in the persistence/secondary statements map from local storage when success from DLS received
         *  @param {Object} statementObject
         *  @param {String} key - LS Key Namespace
         */

    }, {
        key: 'deleteSuccessStatementsFromMap',
        value: function deleteSuccessStatementsFromMap(statementObject, key) {
            /* If success for primary received statements needs to be deleted from secondary map */
            if (key === this.primaryStatementKey) key = this.secondaryStatementKey;

            var localStorageData = void 0;
            this.settings.getData(key, function (data) {
                if (data) {
                    localStorageData = data;
                }
            });

            /* Delete all statements from secondary/persistence map when success received */
            if (localStorageData && localStorageData.entities.length > 0) {
                var successStatements = statementObject.entities;
                /* For secondary map only attempted statements success needs to be checked */
                if (key === this.secondaryStatementKey) {
                    successStatements = statementObject.entities.filter(function (statement) {
                        return statement.verb === 'attempted' && statement['item-code'] && statement.xapi !== false;
                    });
                }
                successStatements.forEach(function (statement) {
                    var statementIndex = localStorageData.entities.findIndex(function (s1) {
                        return s1.verb === statement.verb && s1['item-code'] === statement['item-code'] && s1['timestamp'] === statement['timestamp'];
                    });
                    if (statementIndex !== -1) {
                        localStorageData.entities.splice(statementIndex, 1);
                    }
                });
            }

            /* Update statements map in local storage */
            if (localStorageData && localStorageData.entities.length > 0) {
                this.settings.putData(key, localStorageData);
            } else this.settings.removeData(key);
        }

        /** Function to post user progress state to API.
         *  @param {String} itemCode - Item Code
         *  @param {Object} stateObject - State object
         *  @param {Object} : userId - Optional, DLS User Id whose state to be posted;
         *                    notifyViaCallback - Optional, If true notify APP via callback provided, if any.
         *                    extUserId - Optional, External User Id of user whose state to be posted.
         *                    updateState - Optional, If true then update state instead of creating new
         *                    isSignedURLReq - Optional, if updated signed url req for audio path in state;
         *                    subType - Optional - req if isSignedURLReq true;
         *                    submissionTypeId - req if isSignedURLReq true;
         */

    }, {
        key: 'postStateToLRS',
        value: async function postStateToLRS(itemCode, stateObject) {
            var _this12 = this;

            var _ref11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                userId = _ref11.userId,
                _ref11$notifyViaCallb = _ref11.notifyViaCallback,
                notifyViaCallback = _ref11$notifyViaCallb === undefined ? false : _ref11$notifyViaCallb,
                extUserId = _ref11.extUserId,
                _ref11$updateState = _ref11.updateState,
                updateState = _ref11$updateState === undefined ? false : _ref11$updateState,
                _ref11$isSignedURLReq = _ref11.isSignedURLReq,
                isSignedURLReq = _ref11$isSignedURLReq === undefined ? false : _ref11$isSignedURLReq,
                subType = _ref11.subType,
                submissionTypeId = _ref11.submissionTypeId;

            if (!$.isEmptyObject(stateObject)) {

                if (!_helper2.default.isStateSizeValid(stateObject)) {
                    return Promise.reject('State size exceeded the limit of 10 KB');
                }
                var selectedItem = encodeURIComponent(itemCode);

                var url = this.serverRoutePrefix + 'api/user/product/progress/state/' + this.selectedProduct + '/' + selectedItem;
                url += await this.getQueryParams();

                var additionalParameters = {};

                if (this.spaceId) {
                    additionalParameters.spaceid = this.spaceId;
                }

                if (this.orgId) {
                    additionalParameters.orgId = this.orgId;
                }

                if (this.classId) {
                    additionalParameters.classid = this.classId;
                }

                if (this.isCBPClass) {
                    additionalParameters.isCBPClass = this.isCBPClass;
                }

                if (userId) {
                    additionalParameters.userid = userId;
                }

                if (this.isTestTypeProduct) {
                    additionalParameters.isTestTypeProduct = this.isTestTypeProduct;
                }

                if (extUserId) {
                    additionalParameters.extUserId = extUserId;
                }

                if (isSignedURLReq) {
                    additionalParameters.isSignedURLReq = isSignedURLReq;
                    if (subType) additionalParameters.subType = subType;
                    if (submissionTypeId) additionalParameters.submissionTypeId = submissionTypeId;
                }

                var data = { stateObject: JSON.stringify(stateObject), queryParameters: additionalParameters };
                var requestType = updateState ? 'PUT' : 'POST';
                var postStateSuccess = function postStateSuccess(response) {
                    if (response && response.success && response.count !== response.success.count) {
                        // eslint-disable-next-line
                        return _postStateError(response);
                    }
                    _this12.networkCallsInProgress--;
                    _this12.eventEmitter.emitEvent('networkCallResponse', [response]);
                    if (notifyViaCallback && _this12.successCallback) _this12.successCallback('postState', response);
                    return response;
                };

                var _postStateError = async function _postStateError(error) {
                    await _this12.handleAjaxError(error, requestType, 'postState', notifyViaCallback, { url: url, data: data, successHandler: postStateSuccess, errorHandler: _postStateError });
                };

                /* Notify app if state call sent */
                if (notifyViaCallback && this.postedCallback) this.postedCallback('postState', stateObject);

                this.networkCallsInProgress++;
                return _helper2.default.sendAjaxRequest(url, postStateSuccess, _postStateError, requestType, { userId: this.userDetails.extUserId }, data);
            } else {
                return Promise.resolve('success');
            }
        }

        /**
         * Funcion to handle error in AJAX Request
         * @param {*} error - Error
         * @param {('GET'|'POST'|'PUT'|'DELETE')} [requestType] - 'GET'/'POST'/'PUT'/'DELETE' Request
         * @param {string} [notifyCallbackType] - 'getState'/'deleteState'/'postState'
         * @param {Boolean} notifyViaCallback
         * @param {*} [options={}] - Other required inputs
         *        {string} url - Request URL
         *        {*} data - Request payload
         *        {Function} successHandler - Success callback
         *        {Function} errorHandler - Error handler
         */

    }, {
        key: 'handleAjaxError',
        value: async function handleAjaxError(error, requestType, notifyCallbackType, notifyViaCallback) {
            var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            if (error.status === 503 || error.status === 403 && error.responseJSON && error.responseJSON.code === 'STALE_REQUEST') {
                window.location.reload();
            } else if (error.status === 401 && error.responseJSON && error.responseJSON.errorCode === 'USER_MISMATCH_ERROR') {
                sessionStorage.removeItem(this.userAccountSessionKey);
                window.location.reload();
            } else if ((requestType === 'POST' || requestType === 'PUT') && window['gigya'] && error.status === 401 && error.responseJSON && error.responseJSON.errorCode === 'AUTHORIZATION_ERROR') {
                // if user is unauthorized try to login again in dls session using gigya data.
                return await this.unAuthorizedUserReLogin(options.url, options.data, options.successHandler, options.errorHandler);
            } else {
                if (requestType === 'POST' || requestType === 'PUT') {
                    this.networkCallsInProgress--;
                    this.eventEmitter.emitEvent('networkCallResponse', [error]);
                }
                if (notifyViaCallback && this.errorCallback) this.errorCallback(notifyCallbackType, error);else throw error;
            }
        }

        /** Get userData from gigya and re-send the failed request appending userData in QueryParams
         *  The userData is base64 encoded.
         *  @param {String} url - request url
         *  @param {Object} data - data to post
         *  @param {Object} : successCallback - success callback function.
         *  @param {Object} : errorCallback - error callback function
         */

    }, {
        key: 'unAuthorizedUserReLogin',
        value: async function unAuthorizedUserReLogin(url, data, successCallback, errorCallback) {

            this.logInfoToBackend({ sessionRecreationTimestamp: Date.now(), url: url }, 'TYPE=UNAUTHORIZED_SESSION_RECREATION;XAPIAnalytics').catch(function (e) {
                throw e;
            });
            // get user data from Gigya session
            var gigyaUserData = await this.getUserData();
            if (gigyaUserData) {
                var userData = {
                    extUserId: gigyaUserData.UID,
                    role: gigyaUserData.c1UserRole,
                    email: gigyaUserData.profile.email,
                    firstName: gigyaUserData.profile.firstName,
                    lastName: gigyaUserData.profile.lastName
                };
                if (gigyaUserData.profile.email && gigyaUserData.profile.email.indexOf('@cambridge.org') !== -1) {
                    var samlData = await this.getUserSAMLData();
                    if (samlData) {
                        if (samlData.eltCustomerServices === 'true' || samlData.eltSuperAdmin === 'true' || samlData.eltSales === 'true') {
                            userData.samlData = samlData;
                        } else {
                            return this.handleGigyaError('Gigya samlData issue', errorCallback);
                        }
                    }
                }

                // append user data in url
                var testUserData = btoa(encodeURIComponent(JSON.stringify(userData)));
                var userDataParam = url.indexOf('?') !== -1 ? '&userData=' + encodeURIComponent(testUserData) : '?userData=' + encodeURIComponent(testUserData);
                url += userDataParam;
                return _helper2.default.sendAjaxRequest(url, successCallback, errorCallback, 'POST', { userId: this.userDetails.extUserId }, data);
            } else {
                // logout if Gigya session not found.
                return this.handleGigyaError('Gigya session not found', errorCallback);
            }
        }
    }, {
        key: 'handleGigyaError',
        value: async function handleGigyaError(errorMessage, errorCallback) {
            this.logInfoToBackend({ errorMessage: errorMessage }, 'TYPE=GIGYA_LOGOUT_TRIGGERED;XAPIAnalytics').catch(function (e) {
                throw e;
            });
            this.networkCallsInProgress--;
            this.gigyaLogout();
            window.location.href = window.location.origin + '/login';
            return errorCallback(new Error(errorMessage));
        }
    }, {
        key: 'getUserSAMLData',
        value: async function getUserSAMLData() {
            return new Promise(function (resolve) {
                window['gigya'].accounts.getAccountInfo({
                    extraProfileFields: 'samlData',
                    callback: function callback(res) {
                        resolve(res.profile.samlData);
                    }
                });
            });
        }

        // function to get user data from Gigya session

    }, {
        key: 'getUserData',
        value: function getUserData() {
            var _this13 = this;

            return new Promise(function (resolve, reject) {
                var self = _this13;

                if (_this13.gigyaUserData) {
                    resolve(_this13.gigyaUserData);
                    return;
                }
                window['gigya'].accounts.getAccountInfo({
                    include: 'identities-active,loginIDs,profile,data',
                    callback: function callback(res) {

                        if (res.errorCode === 0 && res.UID) {
                            self.gigyaUserData = res;
                            self.gigyaUserData.c1UserRole = self.getC1UserRole(res);
                        } else {
                            self.gigyaUserData = false;
                        }
                        resolve(self.gigyaUserData);
                    }
                });
            });
        }

        /** function to get user role from Gigya data
         *  @param {Object} userData - gigya user data
         */

    }, {
        key: 'getC1UserRole',
        value: function getC1UserRole(userData) {
            if (userData && userData.data && userData.data.eduelt && userData.data.eduelt.instituteRole && userData.data.eduelt.instituteRole.length > 0) {
                var nemoInstitute = userData.data.eduelt.instituteRole.find(function (institute) {
                    return institute.platform === 'nemo';
                });
                if (nemoInstitute) return nemoInstitute.role;
            } else if (userData && userData.data && userData.data.nemo && userData.data.nemo.role) {
                return userData.data.nemo.role;
            } else {
                return '';
            }
        }
    }, {
        key: 'gigyaLogout',
        value: function gigyaLogout() {
            var _this14 = this;

            return new Promise(function (resolve, reject) {
                var self = _this14;
                window['gigya'].accounts.logout({
                    forceProvidersLogout: false,
                    callback: function callback() {
                        self.gigyaUserData = false;
                        resolve();
                    }
                });
            });
        }

        /** Function to clear user item state from local storage; if any.
         *  @param {String} itemCode - Item Code
         *  @param {Object} stateObject
         *                  documentId - Optional for persistent storage
         *                  action - Optional for persistent storage
         *                  isStateToBeCleared - If true remove state from local storage; Default false;
         */

    }, {
        key: 'updateStateInLocalStorage',
        value: function updateStateInLocalStorage(itemCode) {
            var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                stateObject = _ref12.stateObject,
                documentId = _ref12.documentId,
                action = _ref12.action,
                _ref12$isStateToBeCle = _ref12.isStateToBeCleared,
                isStateToBeCleared = _ref12$isStateToBeCle === undefined ? false : _ref12$isStateToBeCle;

            if (this.isPersistentState(itemCode)) {
                var stateItemKey = this.persistentStateKey + '-' + itemCode;
                var stateData = {},
                    keyFound = void 0;
                this.settings.getData(stateItemKey, function (data) {
                    if (data) {
                        stateData = data;
                    }
                });
                Object.keys(stateData).forEach(function (key) {
                    if (!keyFound && key.startsWith(documentId + '-')) {
                        keyFound = key;
                    }
                });

                if (isStateToBeCleared) {
                    if (keyFound) delete stateData[keyFound];
                    if (Object.keys(stateData).length > 0) {
                        this.settings.putData(stateItemKey, stateData);
                    } else this.settings.removeData(stateItemKey);
                } else {
                    if (keyFound) stateData[keyFound] = stateObject;else stateData[documentId + '-' + action] = stateObject;
                    this.settings.putData(stateItemKey, stateData);
                }
            } else {
                var _stateItemKey = this.stateKey + '-' + itemCode;
                if (isStateToBeCleared) this.settings.removeData(_stateItemKey);else this.settings.putData(_stateItemKey, stateObject);
            }
        }

        /** Function to create statement object from state for persistent(drive) state storage
         *  If entities array is not passed, create entity object first;
         *  @param {Object} : entitiesArr, itemCode, stateObject, documentId, action
         */

    }, {
        key: 'createStatementObjectForState',
        value: function createStatementObjectForState() {
            var _statementObject$enti;

            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                entitiesArr = _ref13.entitiesArr,
                itemCode = _ref13.itemCode,
                stateObject = _ref13.stateObject,
                documentId = _ref13.documentId,
                action = _ref13.action;

            if (!entitiesArr) entitiesArr = this.createStatementEntitiesForState(itemCode, stateObject, documentId, action);
            var statementObject = _helper2.default.createStatementObject([{
                json: {
                    context: {
                        platform: {
                            ua: window.navigator.userAgent
                        }
                    }
                }
            }], this.getStatementDataOptions());
            (_statementObject$enti = statementObject.entities).push.apply(_statementObject$enti, _toConsumableArray(entitiesArr));
            return statementObject;
        }

        /** Function to create statement entities objects from state for persistent(drive) state storage
         *  @param {String} itemCode
         *  @param {String} stateObject
         *  @param {String} documentId
         *  @param {String} action
         */

    }, {
        key: 'createStatementEntitiesForState',
        value: function createStatementEntitiesForState(itemCode, stateObject, documentId, action) {
            var entitiesArr = [{
                verb: 'settings-updated',
                'item-code': itemCode,
                timestamp: Date.now(),
                ttl: 365,
                'user_data': {
                    documentid: documentId,
                    action: action,
                    type: 'activity-state',
                    folderid: 'activity-state/' + this.spaceId + '/' + this.selectedProduct + '/' + itemCode,
                    payload: JSON.stringify(stateObject)
                }
            }];

            if (this.isCBPClass) {
                var folderIdForCBP = 'activity-state/' + this.spaceId + '/' + this.selectedProduct + '/' + this.classId + '/' + itemCode;

                // If product is test type, only create an entity for CBP
                if (this.isTestTypeProduct) {
                    entitiesArr[0].user_data.folderid = folderIdForCBP;
                } else {
                    // else create entity for CBP, along with for non-CBP
                    entitiesArr.push({
                        verb: 'settings-updated',
                        'item-code': itemCode,
                        timestamp: Date.now(),
                        ttl: 365,
                        'user_data': {
                            documentid: documentId,
                            action: action,
                            type: 'activity-state',
                            folderid: folderIdForCBP,
                            payload: JSON.stringify(stateObject)
                        }
                    });
                }
            }

            return entitiesArr;
        }

        /** Function to create persistent(drive)state object/map from statement
         *  @param {Object} statmentObj
         */

    }, {
        key: 'createStateObjectFromStatement',
        value: function createStateObjectFromStatement(statmentObj) {
            var stateObj = {};
            statmentObj.entities.forEach(function (entity) {
                var key = entity['item-code'] + '-' + entity['user_data'].documentid + '-' + entity['user_data'].action;
                stateObj[key] = JSON.parse(entity['user_data'].payload);
            });
            return stateObj;
        }

        /** Function to log info to backend
         *  @param {Object} data
         *  @param {String} context
         */

    }, {
        key: 'logInfoToBackend',
        value: async function logInfoToBackend(data, context) {
            return _helper2.default.logInfoToBackend(context, this.userDetails.extUserId, this.spaceId, this.selectedProduct, this.classId, data, {
                serverRoutePrefix: this.serverRoutePrefix,
                queryParams: await this.getQueryParams()
            });
        }

        /* Helper function to get query param obj, if any and return query params string */

    }, {
        key: 'getQueryParams',
        value: async function getQueryParams() {
            if (this.getQueryParamsObj) {
                var queryParamsObj = await this.getQueryParamsObj();
                if (queryParamsObj && Object.keys(queryParamsObj).length > 0) {
                    return '?' + Object.keys(queryParamsObj).map(function (key) {
                        return key + '=' + queryParamsObj[key];
                    }).join('&');
                }
            }
            return '';
        }

        /* Function to check if persistent state storage for an item */

    }, {
        key: 'isPersistentState',
        value: function isPersistentState(itemCode) {
            return this.persistentState['*'] || this.persistentState[itemCode];
        }

        /* Function to return data to be populated within statements */

    }, {
        key: 'getStatementDataOptions',
        value: function getStatementDataOptions() {
            return {
                productCode: this.selectedProduct,
                spaceId: this.spaceId,
                userDetails: this.userDetails,
                classId: this.classId,
                assignedPathId: this.assignedPathId,
                platformId: this.platformId,
                xapiId: this.xapiId
            };
        }

        /** Helper function to add pagehide event on window object */

    }, {
        key: 'addEventListnersOnInitialization',
        value: function addEventListnersOnInitialization() {
            var _this15 = this;

            window.addEventListener('pagehide', function () {
                _this15.sessionSettings.putData('navigatedOut', true);
            });
        }
    }]);

    return XAPIAnalytics;
}();

exports.XAPIAnalytics = XAPIAnalytics;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionSettings = function () {
    function SessionSettings() {
        _classCallCheck(this, SessionSettings);

        /* sessionStorage may be disabled due to zero-quota issues (e.g. iPad in private browsing mode) */
        this._isSessionStorageEnabled = undefined;
        this.sessionStorageNamespace = 'comprodls.analytics';
        this.version = '1.0.0';
    }

    /**
     * Purpose: To check if session storage is enabled in browser or not.
     * Input Parameter :none
     * Output : true or false.
     */


    _createClass(SessionSettings, [{
        key: 'isSessionStorageEnabled',
        value: function isSessionStorageEnabled() {
            if (this._isSessionStorageEnabled) {
                return true;
            }
            if (this._isSessionStorageEnabled === undefined) {
                this._isSessionStorageEnabled = false;
                var storage = window.sessionStorage;
                if (storage) {
                    try {
                        storage.setItem('isEnabled', '?');
                        storage.removeItem('isEnabled');
                        this._isSessionStorageEnabled = true;
                    } catch (e) {}
                }
                return this._isSessionStorageEnabled;
            } else {
                return false;
            }
        }

        /**
         * Purpose: To set a value for corresponding key in sessionstorage
         * Input Parameter :key, value and callback function
         * Output : none
         */

    }, {
        key: 'putData',
        value: function putData(key, val, callback) {
            if (!this.isSessionStorageEnabled()) {
                if (callback) {
                    callback();
                }
                return;
            }

            sessionStorage[this.sessionStorageNamespace + '.' + key + '-' + this.version] = JSON.stringify(val);

            if (callback) {
                callback();
            }
        }

        /**
         * Purpose: To get a value for corresponding key in sessionstorage
         * Input Parameter :key
         * Output : Value for the corresponding key.
         */

    }, {
        key: 'getData',
        value: function getData(key) {
            if (!this.isSessionStorageEnabled()) {
                return;
            }

            var val = sessionStorage[this.sessionStorageNamespace + '.' + key + '-' + this.version];
            if (val) {
                return JSON.parse(val);
            } else {
                return null;
            }
        }

        /**
         * Purpose: To remove a specific key from sessionStorage.
         */

    }, {
        key: 'removeData',
        value: function removeData(key, callback) {
            if (!this.isSessionStorageEnabled()) {
                if (callback) {
                    callback();
                }
                return;
            }
            sessionStorage.removeItem(this.sessionStorageNamespace + '.' + key + '-' + this.version);
            if (callback) {
                callback();
            }
        }
    }]);

    return SessionSettings;
}();

exports.default = SessionSettings;
module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["nanoid"] = __webpack_require__(32);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nanoid", function() { return nanoid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customAlphabet", function() { return customAlphabet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customRandom", function() { return customRandom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "random", function() { return random; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__url_alphabet_index_js__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "urlAlphabet", function() { return __WEBPACK_IMPORTED_MODULE_0__url_alphabet_index_js__["a"]; });
// This file replaces `index.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.



if (process.env.NODE_ENV !== 'production') {
  // All bundlers will remove this block in the production bundle.
  if (
    typeof navigator !== 'undefined' &&
    navigator.product === 'ReactNative' &&
    typeof crypto === 'undefined'
  ) {
    throw new Error(
      'React Native does not have a built-in secure random generator. ' +
        'If you don’t need unpredictable IDs use `nanoid/non-secure`. ' +
        'For secure IDs, import `react-native-get-random-values` ' +
        'before Nano ID. If you use Expo, install `expo-random` ' +
        'and use `nanoid/async`.'
    )
  }
  if (typeof msCrypto !== 'undefined' && typeof crypto === 'undefined') {
    throw new Error(
      'Import file with `if (!window.crypto) window.crypto = window.msCrypto`' +
        ' before importing Nano ID to fix IE 11 support'
    )
  }
  if (typeof crypto === 'undefined') {
    throw new Error(
      'Your browser does not have secure random generator. ' +
        'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
    )
  }
}

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))

let customRandom = (alphabet, size, getRandom) => {
  // First, a bitmask is necessary to generate the ID. The bitmask makes bytes
  // values closer to the alphabet size. The bitmask calculates the closest
  // `2^31 - 1` number, which exceeds the alphabet size.
  // For example, the bitmask for the alphabet size 30 is 31 (00011111).
  // `Math.clz32` is not used, because it is not available in browsers.
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  // Though, the bitmask solution is not perfect since the bytes exceeding
  // the alphabet size are refused. Therefore, to reliably generate the ID,
  // the random bytes redundancy has to be satisfied.

  // Note: every hardware random generator call is performance expensive,
  // because the system call for entropy collection takes a lot of time.
  // So, to avoid additional system calls, extra bytes are requested in advance.

  // Next, a step determines how many random bytes to generate.
  // The number of random bytes gets decided upon the ID size, mask,
  // alphabet size, and magic number 1.6 (using 1.6 peaks at performance
  // according to benchmarks).

  // `-~f => Math.ceil(f)` if f is a float
  // `-~i => i + 1` if i is an integer
  let step = -~((1.6 * mask * size) / alphabet.length)

  return () => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      // A compact alternative for `for (var i = 0; i < step; i++)`.
      let j = step
      while (j--) {
        // Adding `|| ''` refuses a random byte that exceeds the alphabet size.
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}

let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random)

let nanoid = (size = 21) => {
  let id = ''
  let bytes = crypto.getRandomValues(new Uint8Array(size))

  // A compact alternative for `for (var i = 0; i < step; i++)`.
  while (size--) {
    // It is incorrect to use bytes exceeding the alphabet size.
    // The following mask reduces the random byte in the 0-255 value
    // range to the 0-63 value range. Therefore, adding hacks, such
    // as empty string fallback or magic numbers, is unneccessary because
    // the bitmask trims bytes down to the alphabet size.
    let byte = bytes[size] & 63
    if (byte < 36) {
      // `0-9a-z`
      id += byte.toString(36)
    } else if (byte < 62) {
      // `A-Z`
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte < 63) {
      id += '_'
    } else {
      id += '-'
    }
  }
  return id
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return urlAlphabet; });
// This alphabet uses `A-Za-z0-9_-` symbols. The genetic algorithm helped
// optimize the gzip compression for this alphabet.
let urlAlphabet =
  'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW'




/***/ })
/******/ ]);
});
